var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _g, _path375, _path376, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 627,
    viewBox: "0 0 842 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M841.868 550.978H0.715942V551.398H841.868V550.978Z",
    fill: "#658696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M757.584 578.046H701.867V578.466H757.584V578.046Z",
    fill: "#658696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.929 582.622H543.309V583.043H557.929V582.622Z",
    fill: "#658696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M700.184 562.434H667.901V562.855H700.184V562.434Z",
    fill: "#658696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.628 565.26H88.9695V565.681H161.628V565.26Z",
    fill: "#658696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.267 565.26H176.618V565.681H187.267V565.26Z",
    fill: "#658696"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M379.487 572.36H221.888V572.78H379.487V572.36Z",
    fill: "#658696"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M399.422 475.947H74.5859C72.0412 475.943 69.6022 474.929 67.8044 473.128C66.0065 471.327 64.9968 468.886 64.9968 466.341V9.71325C65.0189 7.1831 66.0385 4.76387 67.8339 2.98103C69.6293 1.19819 72.0557 0.195741 74.5859 0.191406H399.422C401.97 0.191406 404.413 1.20346 406.214 3.00493C408.016 4.80639 409.028 7.2497 409.028 9.79736V466.341C409.028 468.889 408.016 471.332 406.214 473.133C404.413 474.935 401.97 475.947 399.422 475.947ZM74.5859 0.527868C72.1527 0.532325 69.8207 1.50203 68.1018 3.22414C66.3828 4.94625 65.4174 7.28004 65.4174 9.71325V466.341C65.4174 468.774 66.3828 471.108 68.1018 472.83C69.8207 474.552 72.1527 475.522 74.5859 475.526H399.422C401.857 475.522 404.191 474.553 405.912 472.831C407.634 471.11 408.603 468.776 408.607 466.341V9.71325C408.603 7.2785 407.634 4.94474 405.912 3.22311C404.191 1.50148 401.857 0.532315 399.422 0.527868H74.5859Z",
    fill: "#658696"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M763.321 475.947H438.468C435.922 475.943 433.481 474.929 431.681 473.129C429.88 471.328 428.867 468.887 428.862 466.341V9.71325C428.889 7.18157 429.912 4.76236 431.71 2.97998C433.508 1.19761 435.936 0.195693 438.468 0.191406H763.321C765.848 0.200162 768.271 1.20457 770.062 2.98694C771.854 4.7693 772.871 7.18601 772.893 9.71325V466.341C772.893 468.883 771.886 471.321 770.092 473.122C768.298 474.922 765.863 475.938 763.321 475.947ZM438.468 0.527868C436.033 0.532315 433.7 1.50148 431.978 3.22311C430.256 4.94474 429.287 7.2785 429.283 9.71325V466.341C429.287 468.776 430.256 471.11 431.978 472.831C433.7 474.553 436.033 475.522 438.468 475.526H763.321C765.756 475.522 768.09 474.553 769.811 472.831C771.533 471.11 772.502 468.776 772.507 466.341V9.71325C772.502 7.2785 771.533 4.94474 769.811 3.22311C768.09 1.50148 765.756 0.532315 763.321 0.527868H438.468Z",
    fill: "#658696"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M652.811 487.269C652.811 487.269 672.881 458.535 659.035 425.562C645.19 392.589 653.332 380.022 653.332 380.022L666.791 406.72C666.791 406.72 679.391 387.004 674.445 363.838C669.499 340.673 680.888 301.728 680.888 301.728C680.888 301.728 676.783 346.813 683.984 364.713C683.984 364.713 694.515 347.352 698.267 329.822C702.018 312.292 713.525 277.671 713.525 277.671L695.894 385.002L734.587 336.568C734.587 336.568 695.205 402.178 689.956 414.98L732.754 393.615C732.754 393.615 711.792 426.521 695.188 432.813C678.584 439.105 660.566 490.415 660.566 490.415L652.811 487.269Z",
    fill: "#658696"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M667.077 500.172C667.077 500.172 649.648 464.844 670.559 430.659C691.47 396.475 684.572 381.099 684.572 381.099L665.226 408.453C665.226 408.453 654.543 384.446 663.964 359.582C673.385 334.717 667.329 289.581 667.329 289.581C667.329 289.581 664.284 340.303 653.282 358.959C653.282 358.959 644.534 337.914 643.322 317.827C642.111 297.74 635.18 257.382 635.18 257.382L636.644 379.45L601.955 319.19C601.955 319.19 634.591 398.628 638.259 413.718L594.367 382.815C597.126 381.704 621.991 418.883 629.443 432.628C638.948 450.123 658.144 502.359 658.144 502.359L667.077 500.172Z",
    fill: "#37474F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M609.121 484.829H713.104L704.693 551.583H617.533L609.121 484.829Z",
    fill: "#37474F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M412.359 92.1294H111.378V301.778H412.359V92.1294Z",
    fill: "#1C262B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.632 100.423H120.967V293.888H407.632V100.423Z",
    fill: "#37474F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.352 100.423L162.688 293.888H136.242L187.788 100.423H214.352Z",
    fill: "#41525B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.238 100.423L184.592 293.888H174.851L226.498 100.423H236.238Z",
    fill: "#41525B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M407.632 151.38L369.578 293.888H359.837L407.632 114.891V151.38Z",
    fill: "#41525B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M372.909 100.423H399.119L347.876 293.888H321.313L372.909 100.423Z",
    fill: "#41525B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M265.225 92.1294H258.495V301.778H265.225V92.1294Z",
    fill: "#1C262B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M727.084 103.62H478.625V243.049H727.084V103.62Z",
    fill: "#658696"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M721.785 107.623H483.924V239.028H721.785V107.623Z",
    fill: "#37474F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M502.396 122.714H500.629V227.353H502.396V122.714Z",
    fill: "#658696"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M704.676 225.284H501.016V227.353H704.676V225.284Z",
    fill: "#658696"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M510.824 212.027L509.243 210.866L540.298 168.489L545.042 174.512L565.213 153.752L577.914 163.829L602.325 128.568L621.251 187.97L631.277 169.684L636.223 173.099L660.314 154.173L663.645 161.962L699.124 136.593L700.268 138.191L662.803 164.99L659.506 157.302L636.29 175.521L631.95 172.527L620.763 192.933L601.669 132.976L578.335 166.672L565.381 156.393L544.891 177.49L540.349 171.736L510.824 212.027Z",
    fill: "#658696"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M421.292 626.95C601.437 626.95 747.474 618.424 747.474 607.907C747.474 597.389 601.437 588.863 421.292 588.863C241.147 588.863 95.11 597.389 95.11 607.907C95.11 618.424 241.147 626.95 421.292 626.95Z",
    fill: "#37474F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.788 612.517H272.492L253.97 354.721H267.647L282.788 612.517Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M282.805 612.517H272.492L254.879 367.523L253.97 355.125H267.647L268.388 367.523L282.805 612.517Z",
    fill: "#1C262B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.388 366.901H254.879L253.97 355.125H267.647L268.388 366.901Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M526.655 612.517H516.359L514.677 354.721H528.337L526.655 612.517Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M528.354 355.125L528.085 396.728L526.672 612.517H516.359L514.946 396.728L514.677 355.125H528.354Z",
    fill: "#1C262B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M528.354 355.125L528.085 397.182H514.946L514.677 355.125H528.354Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M636.072 612.517H625.776L607.254 354.721H620.931L636.072 612.517Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M636.089 612.517H625.776L608.162 367.523L607.254 355.125H620.931L621.671 367.523L636.089 612.517Z",
    fill: "#1C262B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M621.671 366.901H608.162L607.254 355.125H620.931L621.671 366.901Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M164.892 612.517H154.596L169.737 354.721H183.414L164.892 612.517Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.414 355.125L182.506 367.523L164.892 612.517H154.596L168.997 367.523L169.737 355.125H183.414Z",
    fill: "#1C262B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.737 355.125H183.414L182.506 366.901H168.997L169.737 355.125Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M158.853 348.261H631.765V357.53C631.765 358.494 631.382 359.418 630.701 360.1C630.019 360.781 629.095 361.164 628.131 361.164H162.537C162.055 361.171 161.578 361.082 161.131 360.902C160.684 360.722 160.278 360.456 159.935 360.118C159.592 359.78 159.32 359.377 159.134 358.932C158.948 358.488 158.853 358.012 158.853 357.53V348.261Z",
    fill: "url(#paint0_linear_2280_9187)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M158.853 348.261H631.765V357.53C631.765 358.494 631.382 359.418 630.701 360.1C630.019 360.781 629.095 361.164 628.131 361.164H162.537C162.055 361.171 161.578 361.082 161.131 360.902C160.684 360.722 160.278 360.456 159.935 360.118C159.592 359.78 159.32 359.377 159.134 358.932C158.948 358.488 158.853 358.012 158.853 357.53V348.261Z",
    fill: "#1C262B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M631.765 348.261H158.903V354.721H631.765V348.261Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M638.158 349.943H152.51C151.547 349.943 150.622 349.56 149.941 348.879C149.259 348.197 148.877 347.273 148.877 346.309C148.877 345.344 149.259 344.418 149.94 343.734C150.621 343.05 151.545 342.663 152.51 342.659H638.158C639.123 342.663 640.047 343.05 640.728 343.734C641.409 344.418 641.792 345.344 641.792 346.309C641.792 346.786 641.698 347.259 641.515 347.7C641.332 348.141 641.065 348.541 640.727 348.879C640.39 349.216 639.989 349.484 639.548 349.666C639.108 349.849 638.635 349.943 638.158 349.943Z",
    fill: "url(#paint1_linear_2280_9187)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M638.158 349.943H152.51C151.547 349.943 150.622 349.56 149.941 348.879C149.259 348.197 148.877 347.273 148.877 346.309C148.877 345.344 149.259 344.418 149.94 343.734C150.621 343.05 151.545 342.663 152.51 342.659H638.158C639.123 342.663 640.047 343.05 640.728 343.734C641.409 344.418 641.792 345.344 641.792 346.309C641.792 346.786 641.698 347.259 641.515 347.7C641.332 348.141 641.065 348.541 640.727 348.879C640.39 349.216 639.989 349.484 639.548 349.666C639.108 349.849 638.635 349.943 638.158 349.943Z",
    fill: "#1C262B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M383.625 342.659L385.274 336.384H453.508L484.917 339.529L486.111 342.659H383.625Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M453.508 336.384V342.659H383.625L385.274 336.384H453.508Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M625.339 43.2921H446.762V170.71H625.339V43.2921Z",
    fill: "url(#paint2_linear_2280_9187)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M625.339 43.2921H446.762V170.71H625.339V43.2921Z",
    fill: "#1C262B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M612.957 47.1279H504.246V53.4701H612.957V47.1279Z",
    fill: "#658696"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M477.38 77.2916C484.478 77.2916 490.233 71.5372 490.233 64.4388C490.233 57.3404 484.478 51.586 477.38 51.586C470.281 51.586 464.527 57.3404 464.527 64.4388C464.527 71.5372 470.281 77.2916 477.38 77.2916Z",
    fill: "#37474F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M485.135 85.7367H464.527V106.345H485.135V85.7367Z",
    fill: "url(#paint3_linear_2280_9187)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.135 85.7367H464.527V106.345H485.135V85.7367Z",
    fill: "#1C262B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M507.056 85.7367H486.448V106.345H507.056V85.7367Z",
    fill: "url(#paint4_linear_2280_9187)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M507.056 85.7367H486.448V106.345H507.056V85.7367Z",
    fill: "#1C262B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M531.012 85.7367H508.368V128.282H531.012V85.7367Z",
    fill: "url(#paint5_linear_2280_9187)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M531.012 85.7367H508.368V128.282H531.012V85.7367Z",
    fill: "#1C262B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M485.135 107.657H464.527V128.265H485.135V107.657Z",
    fill: "url(#paint6_linear_2280_9187)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.135 107.657H464.527V128.265H485.135V107.657Z",
    fill: "#1C262B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M496.928 136.996H464.527V169.398H496.928V136.996Z",
    fill: "url(#paint7_linear_2280_9187)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M496.928 136.996H464.527V169.398H496.928V136.996Z",
    fill: "#1C262B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M513.903 136.996H497.702V153.197H513.903V136.996Z",
    fill: "url(#paint8_linear_2280_9187)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M513.903 136.996H497.702V153.197H513.903V136.996Z",
    fill: "#1C262B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M513.903 153.937H497.702V169.398H513.903V153.937Z",
    fill: "url(#paint9_linear_2280_9187)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M513.903 153.937H497.702V169.398H513.903V153.937Z",
    fill: "#1C262B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M531.012 136.996H514.811V153.197H531.012V136.996Z",
    fill: "url(#paint10_linear_2280_9187)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M531.012 136.996H514.811V153.197H531.012V136.996Z",
    fill: "#1C262B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M531.012 153.937H514.811V169.398H531.012V153.937Z",
    fill: "url(#paint11_linear_2280_9187)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M531.012 153.937H514.811V169.398H531.012V153.937Z",
    fill: "#1C262B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M507.056 107.657H486.448V128.265H507.056V107.657Z",
    fill: "url(#paint12_linear_2280_9187)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M507.056 107.657H486.448V128.265H507.056V107.657Z",
    fill: "#1C262B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M561.714 85.7367H541.106V106.345H561.714V85.7367Z",
    fill: "url(#paint13_linear_2280_9187)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M561.714 85.7367H541.106V106.345H561.714V85.7367Z",
    fill: "#1C262B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M583.634 85.7367H563.026V106.345H583.634V85.7367Z",
    fill: "url(#paint14_linear_2280_9187)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M583.634 85.7367H563.026V106.345H583.634V85.7367Z",
    fill: "#1C262B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59 85.7367H584.946V128.282H607.59V85.7367Z",
    fill: "url(#paint15_linear_2280_9187)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M607.59 85.7367H584.946V128.282H607.59V85.7367Z",
    fill: "#1C262B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M561.714 107.657H541.106V128.265H561.714V107.657Z",
    fill: "url(#paint16_linear_2280_9187)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M561.714 107.657H541.106V128.265H561.714V107.657Z",
    fill: "#1C262B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M573.507 136.996H541.106V169.398H573.507V136.996Z",
    fill: "url(#paint17_linear_2280_9187)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M573.507 136.996H541.106V169.398H573.507V136.996Z",
    fill: "#1C262B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M590.481 136.996H574.281V153.197H590.481V136.996Z",
    fill: "url(#paint18_linear_2280_9187)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M590.481 136.996H574.281V153.197H590.481V136.996Z",
    fill: "#1C262B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M590.481 153.937H574.281V169.398H590.481V153.937Z",
    fill: "url(#paint19_linear_2280_9187)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M590.481 153.937H574.281V169.398H590.481V153.937Z",
    fill: "#1C262B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59 136.996H591.39V153.197H607.59V136.996Z",
    fill: "url(#paint20_linear_2280_9187)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M607.59 136.996H591.39V153.197H607.59V136.996Z",
    fill: "#1C262B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59 153.937H591.39V169.398H607.59V153.937Z",
    fill: "url(#paint21_linear_2280_9187)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M607.59 153.937H591.39V169.398H607.59V153.937Z",
    fill: "#1C262B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M583.634 107.657H563.026V128.265H583.634V107.657Z",
    fill: "url(#paint22_linear_2280_9187)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M583.634 107.657H563.026V128.265H583.634V107.657Z",
    fill: "#1C262B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M531.012 130.133H516.359V134.574H531.012V130.133Z",
    fill: "url(#paint23_linear_2280_9187)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M531.012 130.133H516.359V134.574H531.012V130.133Z",
    fill: "#1C262B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59 130.133H592.937V134.574H607.59V130.133Z",
    fill: "url(#paint24_linear_2280_9187)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M607.59 130.133H592.937V134.574H607.59V130.133Z",
    fill: "#1C262B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M522.92 66.4911H494.119V70.6296H522.92V66.4911Z",
    fill: "#658696"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M534.797 74.1121H494.119V75.6934H534.797V74.1121Z",
    fill: "#658696"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M538.397 76.5008H494.119V78.0822H538.397V76.5008Z",
    fill: "#658696"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59 59.9974H595.326V64.4387H607.59V59.9974Z",
    fill: "url(#paint25_linear_2280_9187)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M607.59 59.9974H595.326V64.4387H607.59V59.9974Z",
    fill: "#1C262B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M592.719 59.9974H578.066V64.4387H592.719V59.9974Z",
    fill: "url(#paint26_linear_2280_9187)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M592.719 59.9974H578.066V64.4387H592.719V59.9974Z",
    fill: "#1C262B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M483.352 130.133H464.527V132.925H483.352V130.133Z",
    fill: "#658696"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M490.165 64.4723C490.168 62.5088 489.72 60.5707 488.857 58.8073C487.993 57.0439 486.736 55.5022 485.183 54.3008C483.63 53.0995 481.821 52.2704 479.898 51.8776C477.974 51.4847 475.985 51.5385 474.085 52.0347C472.186 52.531 470.425 53.4565 468.939 54.74C467.453 56.0236 466.281 57.6309 465.514 59.4384C464.747 61.2459 464.404 63.2053 464.513 65.1659C464.622 67.1265 465.179 69.036 466.142 70.7473C466.762 69.968 467.649 69.4464 468.632 69.2837C468.822 69.267 469.014 69.267 469.204 69.2837C470.475 69.1997 471.751 69.1997 473.023 69.2837C474.867 69.3981 476.704 69.6171 478.524 69.9398C479.763 70.2188 480.978 70.5957 482.158 71.067C482.694 71.2804 483.175 71.6121 483.566 72.0373C483.956 72.4626 484.245 72.9705 484.412 73.5231C484.58 73.9774 484.732 74.4484 484.849 74.9026C486.501 73.7121 487.845 72.1447 488.769 70.3307C489.694 68.5167 490.173 66.5084 490.165 64.4723Z",
    fill: "#37474F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M484.412 73.5064C484.245 72.9537 483.956 72.4458 483.566 72.0205C483.175 71.5953 482.694 71.2636 482.158 71.0502C480.978 70.5789 479.763 70.202 478.524 69.923C476.704 69.6003 474.867 69.3813 473.023 69.267C471.751 69.1829 470.475 69.1829 469.204 69.267C469.014 69.2502 468.822 69.2502 468.632 69.267C467.649 69.4296 466.762 69.9512 466.142 70.7306C467.255 72.7201 468.878 74.3769 470.845 75.5302C472.811 76.6835 475.05 77.2915 477.329 77.2915C479.146 77.3083 480.944 76.9234 482.595 76.1644C483.39 75.8125 484.145 75.3783 484.849 74.869C484.732 74.4316 484.58 73.9606 484.412 73.5064Z",
    fill: "url(#paint27_linear_2280_9187)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M474.318 63.1265C474.453 64.9434 474.402 68.1734 473.023 69.2669C474.652 70.2211 476.113 71.4375 477.346 72.867C477.984 72.0026 478.39 70.9889 478.524 69.923C476.606 69.2164 476.842 67.7528 477.346 66.4238L474.318 63.1265Z",
    fill: "#FFB573"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M475.546 64.4725L477.346 66.424C477.213 66.7309 477.117 67.0529 477.06 67.3829C476.628 67.2436 476.242 66.9878 475.945 66.6435C475.648 66.2993 475.452 65.8799 475.378 65.4314C475.374 65.1041 475.431 64.7789 475.546 64.4725Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M480.728 57.6758C482.41 58.6684 481.216 62.7227 480.358 63.0256C478.743 63.5975 478.591 56.4477 480.728 57.6758Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M474.436 60.4517C474.284 62.8574 474.083 64.2705 475.142 65.6332C475.503 66.0832 475.977 66.428 476.516 66.6316C477.056 66.8351 477.64 66.8899 478.207 66.7901C478.775 66.6903 479.305 66.4397 479.743 66.0645C480.18 65.6893 480.509 65.2033 480.694 64.6575C481.468 62.5546 481.569 58.9713 479.331 57.7264C478.838 57.4723 478.29 57.3441 477.736 57.353C477.182 57.3619 476.638 57.5077 476.153 57.7774C475.669 58.0471 475.259 58.4324 474.959 58.899C474.659 59.3655 474.48 59.8989 474.436 60.4517Z",
    fill: "#FFB573"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M472.72 58.332C472.484 59.7283 473.628 63.6817 474.638 63.7154C475.647 63.749 476.219 61.5957 475.95 59.5601C476.909 59.3919 482.814 60.1489 482.074 57.6423C481.914 57.211 481.635 56.8345 481.268 56.5572C480.901 56.2799 480.463 56.1135 480.004 56.0777C479.196 55.3156 478.175 54.8169 477.077 54.6478C477.868 55.5226 477.851 55.7244 477.329 55.6067C476.705 55.4624 476.109 55.2181 475.563 54.8833C475.48 55.2317 475.48 55.5947 475.563 55.9431C475.26 55.8086 475.058 55.3039 473.04 55.5394C473.83 56.145 473.527 56.4983 473.292 56.5656C472.713 56.7917 472.071 56.7917 471.492 56.5656C471.561 56.9297 471.706 57.2752 471.918 57.5795C472.129 57.8838 472.403 58.1402 472.72 58.332Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M473.023 62.9582C473.29 63.5069 473.761 63.9296 474.335 64.1358C475.092 64.405 475.513 63.7321 475.344 62.9919C475.176 62.2517 474.621 61.3096 473.847 61.4273C473.676 61.4431 473.511 61.501 473.367 61.5959C473.223 61.6909 473.106 61.8199 473.024 61.9715C472.942 62.1231 472.899 62.2925 472.899 62.4647C472.899 62.6369 472.941 62.8064 473.023 62.9582Z",
    fill: "#FFB573"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M477.986 61.562C477.986 61.747 477.986 61.9153 478.171 61.9321C478.356 61.9489 478.423 61.8143 478.44 61.6125C478.457 61.4106 478.44 61.2423 478.255 61.2255C478.07 61.2087 478.002 61.3601 477.986 61.562Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M480.173 61.8313C480.173 62.0163 480.173 62.1845 480.358 62.2014C480.543 62.2182 480.61 62.0836 480.627 61.8817C480.644 61.6799 480.627 61.5116 480.442 61.4948C480.257 61.478 480.173 61.6294 480.173 61.8313Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M479.483 61.8312C479.631 62.4542 479.863 63.0541 480.172 63.6145C480.022 63.685 479.859 63.7215 479.693 63.7215C479.527 63.7215 479.364 63.685 479.214 63.6145L479.483 61.8312Z",
    fill: "#ED893E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M478.625 64.119C478.382 64.0956 478.149 64.0147 477.944 63.883C477.74 63.7513 477.569 63.5727 477.447 63.362C477.447 63.362 477.447 63.362 477.363 63.362C477.496 63.5902 477.682 63.7837 477.904 63.9269C478.126 64.0701 478.379 64.159 478.642 64.1863L478.625 64.119Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M477.413 60.7545H477.498C477.597 60.6469 477.721 60.5636 477.858 60.5111C477.995 60.4586 478.142 60.4383 478.288 60.4517C478.308 60.4655 478.332 60.4728 478.356 60.4728C478.38 60.4728 478.403 60.4655 478.423 60.4517C478.423 60.4517 478.423 60.3171 478.322 60.3171C478.14 60.2892 477.954 60.3069 477.781 60.3685C477.608 60.4302 477.453 60.5339 477.329 60.6704C477.31 60.6943 477.3 60.724 477.3 60.7545C477.3 60.7851 477.31 60.8148 477.329 60.8386L477.413 60.7545Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M481.266 61.192C481.28 61.1723 481.287 61.1488 481.287 61.1247C481.287 61.1007 481.28 61.0772 481.266 61.0575C481.208 60.8835 481.111 60.7249 480.983 60.5938C480.855 60.4626 480.698 60.3623 480.526 60.3004C480.504 60.2852 480.477 60.2771 480.45 60.2771C480.423 60.2771 480.397 60.2852 480.374 60.3004C480.371 60.3312 480.378 60.3623 480.393 60.3893C480.408 60.4164 480.431 60.4382 480.459 60.4518C480.599 60.4904 480.728 60.565 480.831 60.6683C480.934 60.7715 481.009 60.8998 481.047 61.0406C481.033 61.0695 481.03 61.1025 481.038 61.1336C481.046 61.1646 481.065 61.1918 481.092 61.21C481.118 61.2283 481.15 61.2366 481.182 61.2333C481.214 61.23 481.244 61.2153 481.266 61.192Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M625.187 99.5483H485.135V170.811H625.187V99.5483Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M671.434 105.773H493.362V217.579H671.434V105.773Z",
    fill: "url(#paint28_linear_2280_9187)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M671.434 105.773H493.362V217.579H671.434V105.773Z",
    fill: "#1C262B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M537.127 140.951C538.764 134.016 534.469 127.066 527.533 125.429C520.597 123.792 513.648 128.088 512.011 135.023C510.374 141.959 514.669 148.908 521.605 150.545C528.541 152.182 535.49 147.887 537.127 140.951Z",
    fill: "#41525B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M504.028 111.829V138.006V192.21H626.365V138.006V111.829H504.028Z",
    fill: "url(#paint29_linear_2280_9187)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M626.382 138.006H504.028V192.21H626.382V138.006Z",
    fill: "#1C262B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M626.382 112.014H504.028V138.191H626.382V112.014Z",
    fill: "#1C262B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M626.382 195.608H504.028V217.579H626.382V195.608Z",
    fill: "url(#paint30_linear_2280_9187)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M626.382 195.608H504.028V217.579H626.382V195.608Z",
    fill: "#1C262B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M665.411 111.829H632.707V215.678H665.411V111.829Z",
    fill: "url(#paint31_linear_2280_9187)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M665.411 111.829H632.707V215.678H665.411V111.829Z",
    fill: "#1C262B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M664.2 113.158H633.935V139.419H664.2V113.158Z",
    fill: "url(#paint32_linear_2280_9187)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M664.2 113.158H633.935V139.419H664.2V113.158Z",
    fill: "#1C262B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M529.599 152.154H512.439V154.055H529.599V152.154Z",
    fill: "#658696"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M538.363 155.199H512.439V157.1H538.363V155.199Z",
    fill: "#658696"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M536.58 157.857H512.439V159.758H536.58V157.857Z",
    fill: "#658696"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M601.181 166.975H512.439V168.944H601.181V166.975Z",
    fill: "#658696"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M607.994 171.988H512.439V173.957H607.994V171.988Z",
    fill: "#658696"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M606.076 177.002H512.439V178.97H606.076V177.002Z",
    fill: "#658696"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M602.947 182.015H512.439V183.983H602.947V182.015Z",
    fill: "#658696"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M651.835 146.754H634.793V149.294H651.835V146.754Z",
    fill: "#658696"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M650.203 152.02H634.793V153.466H650.203V152.02Z",
    fill: "#658696"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M651.835 163.61H634.793V166.151H651.835V163.61Z",
    fill: "#658696"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M650.203 168.876H634.793V170.323H650.203V168.876Z",
    fill: "#658696"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M651.835 180.484H634.793V183.024H651.835V180.484Z",
    fill: "#658696"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M650.203 185.733H634.793V187.18H650.203V185.733Z",
    fill: "#658696"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M651.835 197.341H634.793V199.881H651.835V197.341Z",
    fill: "#658696"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M650.203 202.606H634.793V204.053H650.203V202.606Z",
    fill: "#658696"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M602.947 209.672H512.439V211.64H602.947V209.672Z",
    fill: "#658696"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M609.037 203.061H512.439V205.029H609.037V203.061Z",
    fill: "#658696"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M517.839 143.726C517.839 143.726 518.512 143.591 519.522 143.456C520.419 143.318 521.323 143.228 522.23 143.187C524.107 143.078 525.989 143.078 527.866 143.187C528.669 143.257 529.466 143.375 530.255 143.541L531.13 143.726H531.416H531.584C532.51 144.07 533.361 144.589 534.09 145.256C534.304 145.447 534.501 145.655 534.679 145.879C536.186 143.949 537.11 141.627 537.34 139.189C537.571 136.751 537.099 134.298 535.981 132.119C534.863 129.94 533.145 128.127 531.03 126.893C528.914 125.659 526.49 125.056 524.043 125.155C521.596 125.253 519.229 126.05 517.22 127.451C515.211 128.852 513.645 130.798 512.706 133.06C511.767 135.322 511.495 137.805 511.922 140.216C512.349 142.628 513.456 144.867 515.114 146.67C515.989 145.206 516.931 143.86 517.839 143.726Z",
    fill: "#1C262B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M524.653 150.926C526.599 150.923 528.519 150.478 530.267 149.624C532.016 148.77 533.548 147.53 534.747 145.997C534.568 145.773 534.371 145.565 534.158 145.374C533.429 144.707 532.577 144.188 531.651 143.843H531.483H531.197L530.322 143.658C529.534 143.493 528.736 143.375 527.933 143.305C526.056 143.196 524.174 143.196 522.298 143.305C521.368 143.349 520.441 143.445 519.522 143.591C518.546 143.726 517.839 143.86 517.839 143.86C516.931 143.995 515.989 145.341 515.198 146.922C516.415 148.203 517.882 149.219 519.509 149.908C521.135 150.597 522.886 150.943 524.653 150.926Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M522.23 143.187C524.107 143.078 525.989 143.078 527.866 143.187H528.186C528.325 143.298 528.432 143.443 528.497 143.609C528.562 143.774 528.582 143.954 528.556 144.13C528.421 144.685 527.647 144.87 526.974 144.954C526.956 145.199 526.911 145.442 526.84 145.677L526.621 146.317L526.251 145.761C526.038 145.467 525.776 145.211 525.477 145.004C522.213 144.92 521.726 143.322 521.692 143.322L522.23 143.187Z",
    fill: "#1C262B"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M522.398 136.845L523.896 138.09L525.948 139.772C525.892 140.045 525.853 140.32 525.83 140.597C525.764 140.883 525.76 141.179 525.818 141.467C525.877 141.754 525.996 142.026 526.168 142.264C526.34 142.501 526.562 142.699 526.817 142.844C527.072 142.989 527.355 143.077 527.647 143.103C527.647 143.103 529.582 144.399 526.705 144.634C526.687 144.947 526.636 145.257 526.554 145.56C526.302 145.209 525.988 144.907 525.628 144.668C522.466 144.668 522.045 143.137 522.045 143.137C523.273 141.959 522.802 138.662 522.398 136.845Z",
    fill: "#CE7A63"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M525.948 139.823C525.892 140.095 525.853 140.37 525.83 140.647C525.396 140.552 524.994 140.347 524.661 140.053C524.329 139.758 524.077 139.384 523.929 138.965C523.898 138.702 523.898 138.437 523.929 138.174L525.948 139.823Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M527.277 130.503C528.505 131.058 529.178 134.507 527.63 135.247C526.083 135.987 525.023 129.46 527.277 130.503Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M521.776 134.237C522.298 136.643 522.483 138.073 523.896 139.183C524.356 139.547 524.907 139.777 525.489 139.85C526.071 139.923 526.662 139.835 527.197 139.595C527.733 139.356 528.193 138.975 528.527 138.493C528.861 138.011 529.058 137.447 529.094 136.862C529.279 134.624 528.387 131.058 525.847 130.368C525.301 130.208 524.723 130.194 524.17 130.328C523.618 130.462 523.11 130.739 522.698 131.13C522.285 131.522 521.983 132.015 521.821 132.561C521.66 133.106 521.644 133.684 521.776 134.237Z",
    fill: "#CE7A63"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M518.967 131.832C517.789 132.353 518.462 133.968 519.253 134.978C520.363 136.408 521.54 137.064 522.331 136.408C522.779 135.901 523.071 135.276 523.172 134.608C523.274 133.939 523.18 133.256 522.903 132.639C523.997 131.916 528.101 133.699 529.33 130.705C529.587 130.101 529.629 129.427 529.448 128.796C529.267 128.165 528.875 127.615 528.337 127.239C526.844 128.359 525.021 128.951 523.155 128.921C520.548 129.106 517.789 130.452 518.967 131.832Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M521.221 136.744C521.602 137.217 522.138 137.539 522.735 137.652C523.509 137.787 523.677 137.08 523.29 136.408C522.903 135.735 522.129 134.978 521.44 135.163C520.75 135.348 520.716 136.155 521.221 136.744Z",
    fill: "#CE7A63"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M525.595 134.473C525.595 134.675 525.746 134.81 525.881 134.793C526.015 134.776 526.083 134.608 526.066 134.406C526.049 134.204 525.898 134.069 525.763 134.086C525.629 134.103 525.595 134.271 525.595 134.473Z",
    fill: "#263238"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M527.815 134.204C527.815 134.406 527.984 134.54 528.101 134.524C528.219 134.507 528.32 134.339 528.286 134.154C528.253 133.968 528.135 133.8 528 133.817C527.866 133.834 527.782 134.002 527.815 134.204Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M527.126 134.389C527.458 134.967 527.866 135.498 528.337 135.97C528.214 136.084 528.067 136.168 527.907 136.218C527.747 136.267 527.577 136.28 527.412 136.256L527.126 134.389Z",
    fill: "#BA4D3C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M526.672 136.879C526.207 136.879 525.76 136.698 525.427 136.374C525.606 136.551 525.824 136.685 526.063 136.767C526.301 136.848 526.556 136.875 526.806 136.845L526.672 136.879Z",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M524.771 133.834C524.751 133.81 524.741 133.78 524.741 133.749C524.741 133.719 524.751 133.689 524.771 133.665C524.854 133.513 524.973 133.382 525.116 133.283C525.259 133.183 525.423 133.119 525.595 133.093C525.595 133.093 525.713 133.093 525.713 133.211C525.713 133.24 525.703 133.267 525.684 133.289C525.666 133.311 525.64 133.325 525.612 133.329C525.467 133.344 525.327 133.395 525.207 133.477C525.087 133.559 524.989 133.67 524.922 133.8C524.903 133.82 524.879 133.835 524.852 133.841C524.824 133.847 524.796 133.844 524.771 133.834Z",
    fill: "#263238"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M528.657 133.312C528.644 133.32 528.629 133.324 528.615 133.324C528.6 133.324 528.585 133.32 528.572 133.312C528.491 133.188 528.381 133.083 528.253 133.008C528.125 132.932 527.981 132.886 527.832 132.875C527.802 132.871 527.774 132.858 527.753 132.836C527.732 132.815 527.718 132.787 527.715 132.757C527.715 132.726 527.727 132.696 527.749 132.674C527.771 132.652 527.801 132.639 527.832 132.639C528.018 132.65 528.199 132.704 528.36 132.797C528.52 132.891 528.657 133.021 528.758 133.178C528.758 133.178 528.758 133.312 528.758 133.346L528.657 133.312Z",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M671.434 166.975H541.106V217.327H671.434V166.975Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M686.373 173.183H548.373V259.182H686.373V173.183Z",
    fill: "url(#paint33_linear_2280_9187)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M686.373 173.183H548.373V259.182H686.373V173.183Z",
    fill: "#1C262B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M585.552 231.795H555.287V258.526H585.552V231.795Z",
    fill: "#1C262B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M679.778 175.168H554.16V181.679H679.778V175.168Z",
    fill: "url(#paint34_linear_2280_9187)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M679.778 185.346H554.16V227.404H679.778V185.346Z",
    fill: "url(#paint35_linear_2280_9187)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M679.778 185.346H554.16V227.404H679.778V185.346Z",
    fill: "#1C262B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M583.211 220.58C584.844 213.662 580.56 206.731 573.642 205.098C566.724 203.466 559.793 207.75 558.16 214.668C556.527 221.585 560.812 228.517 567.729 230.149C574.647 231.782 581.578 227.498 583.211 220.58Z",
    fill: "#37474F"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M679.778 231.795H587.268V258.526H679.778V231.795Z",
    fill: "url(#paint36_linear_2280_9187)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M679.778 231.795H587.268V258.526H679.778V231.795Z",
    fill: "#1C262B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M677.978 194.38H589.051V198.334H677.978V194.38Z",
    fill: "#658696"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M677.978 204.407H589.051V208.36H677.978V204.407Z",
    fill: "#658696"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M677.978 215.341H589.051V219.295H677.978V215.341Z",
    fill: "#658696"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M675.623 177.439H648.655V179.424H675.623V177.439Z",
    fill: "#658696"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M572.38 177.725H556.953V179.71H572.38V177.725Z",
    fill: "#658696"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M583.584 237.363H556.616V239.348H583.584V237.363Z",
    fill: "#658696"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M583.584 240.812H556.616V242.797H583.584V240.812Z",
    fill: "#658696"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M583.584 244.243H556.616V246.229H583.584V244.243Z",
    fill: "#658696"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M583.584 247.692H556.616V249.678H583.584V247.692Z",
    fill: "#658696"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M583.584 251.124H556.616V253.109H583.584V251.124Z",
    fill: "#658696"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M677.978 244.395H589.051V248.349H677.978V244.395Z",
    fill: "#658696"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M677.978 250.417H589.051V254.371H677.978V250.417Z",
    fill: "#658696"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M583.55 217.798C583.55 215.502 582.934 213.248 581.766 211.271C580.598 209.294 578.921 207.666 576.91 206.558C574.899 205.449 572.627 204.901 570.332 204.969C568.037 205.038 565.802 205.721 563.86 206.947C561.919 208.173 560.342 209.897 559.294 211.94C558.245 213.983 557.764 216.27 557.901 218.562C558.037 220.855 558.786 223.068 560.069 224.972C561.353 226.877 563.123 228.402 565.196 229.389C565.011 228.8 564.809 228.195 564.591 227.538L563.935 225.57C565.383 225.111 566.861 224.751 568.359 224.494C569.945 224.224 571.546 224.055 573.154 223.989C575.223 223.989 577.612 224.208 577.612 224.208C577.612 224.208 577.948 224.292 578.167 226.495C578.167 226.933 578.251 227.488 578.285 228.178C579.92 226.987 581.25 225.425 582.165 223.621C583.08 221.817 583.555 219.821 583.55 217.798Z",
    fill: "#37474F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M574.466 212.297C574.948 212.636 575.338 213.091 575.6 213.62C575.861 214.149 575.986 214.735 575.963 215.325C575.771 217.062 575.698 218.81 575.744 220.557C575.782 221.777 575.546 222.989 575.054 224.106C574.985 223.447 574.861 222.794 574.684 222.155C574.684 222.155 574.684 222.676 573.961 222.878C573.238 223.08 567.585 223.215 566.306 222.155C565.028 221.095 567.703 212.566 569.166 212.061C570.934 211.851 572.724 211.931 574.466 212.297Z",
    fill: "#263238"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M577.612 224.207C577.612 224.207 575.223 223.989 573.154 223.989C571.546 224.055 569.945 224.224 568.359 224.493C566.861 224.751 565.383 225.11 563.935 225.57L564.591 227.538C564.809 228.194 565.011 228.8 565.196 229.389C567.286 230.383 569.606 230.794 571.91 230.577C574.214 230.361 576.416 229.526 578.285 228.161C578.285 227.488 578.2 226.933 578.167 226.478C577.948 224.291 577.612 224.207 577.612 224.207Z",
    fill: "url(#paint37_linear_2280_9187)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M577.612 224.207C577.612 224.207 575.223 223.989 573.154 223.989C571.546 224.055 569.945 224.224 568.359 224.493C566.861 224.751 565.383 225.11 563.935 225.57L564.591 227.538C564.809 228.194 565.011 228.8 565.196 229.389C567.286 230.383 569.606 230.794 571.91 230.577C574.214 230.361 576.416 229.526 578.285 228.161C578.285 227.488 578.2 226.933 578.167 226.478C577.948 224.291 577.612 224.207 577.612 224.207Z",
    fill: "#1C262B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M568.056 212.448C569.032 210.463 574.23 210.446 575.24 212.347C576.552 214.769 579.176 217.209 578.385 220.59C578.317 220.241 578.18 219.91 577.982 219.614C578.092 220.424 577.903 221.247 577.451 221.928C576.999 222.609 576.315 223.102 575.526 223.315C572.771 223.889 569.913 223.715 567.249 222.811C567.03 222.41 566.931 221.954 566.963 221.499C566.767 221.846 566.712 222.256 566.811 222.643C566.098 222.169 565.574 221.459 565.331 220.638C565.088 219.817 565.142 218.936 565.482 218.151C566.475 215.341 566.088 212.01 568.056 212.448Z",
    fill: "#263238"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M572.262 226.361C570.993 226.326 569.788 225.801 568.897 224.897C570.58 223.316 569.183 220.59 569.183 220.59L572.346 221.179C572.272 221.618 572.232 222.063 572.228 222.508C572.228 224.443 573.069 224.46 573.069 224.46C573.574 225.503 572.262 226.361 572.262 226.361Z",
    fill: "#FFB573"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M572.295 221.179C572.221 221.618 572.182 222.063 572.178 222.508C571.545 222.491 570.928 222.303 570.393 221.966C569.857 221.629 569.422 221.153 569.133 220.59L572.295 221.179Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M566.407 225.183C568.118 226.566 570.192 227.425 572.38 227.656C575.256 227.656 576.266 224.291 576.266 224.291C572.966 223.572 569.525 223.883 566.407 225.183Z",
    fill: "#FFB573"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M572.447 212.835C575.055 213.273 575.643 214.803 575.374 217.512C575.038 220.877 573.894 223.148 570.781 221.886C566.542 220.153 568.14 212.162 572.447 212.835Z",
    fill: "#FFB573"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M573.726 217.091C573.87 217.51 574.062 217.911 574.298 218.286C574.203 218.381 574.083 218.448 573.953 218.481C573.823 218.514 573.686 218.51 573.557 218.471L573.726 217.091Z",
    fill: "#DE5753"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M572.178 216.603C572.178 216.822 572.01 216.973 571.858 216.957C571.778 216.92 571.713 216.856 571.676 216.775C571.639 216.695 571.632 216.604 571.656 216.519C571.656 216.317 571.825 216.149 571.976 216.183C572.127 216.216 572.211 216.385 572.178 216.603Z",
    fill: "#263238"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M571.909 216.183L572.396 216.065C572.396 216.065 572.11 216.418 571.909 216.183Z",
    fill: "#263238"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M574.836 216.94C574.836 217.158 574.668 217.31 574.533 217.293C574.398 217.276 574.298 217.091 574.331 216.872C574.365 216.654 574.499 216.502 574.634 216.519C574.769 216.536 574.869 216.738 574.836 216.94Z",
    fill: "#263238"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M574.583 216.519L575.071 216.401C575.071 216.401 574.785 216.772 574.583 216.519Z",
    fill: "#263238"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M571.269 215.123C571.259 215.113 571.25 215.102 571.244 215.089C571.238 215.076 571.235 215.062 571.235 215.047C571.235 215.033 571.238 215.019 571.244 215.006C571.25 214.993 571.259 214.981 571.269 214.972C571.452 214.834 571.665 214.743 571.89 214.705C572.116 214.667 572.347 214.683 572.565 214.753C572.593 214.761 572.617 214.779 572.633 214.804C572.648 214.829 572.654 214.859 572.649 214.887C572.639 214.898 572.628 214.907 572.615 214.913C572.602 214.919 572.587 214.922 572.573 214.922C572.559 214.922 572.545 214.919 572.531 214.913C572.518 214.907 572.507 214.898 572.497 214.887C572.315 214.837 572.124 214.827 571.938 214.859C571.752 214.891 571.575 214.964 571.421 215.072L571.269 215.123Z",
    fill: "#263238"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M575.357 215.527H575.273C575.161 215.403 575.023 215.305 574.869 215.241C574.715 215.177 574.548 215.148 574.382 215.156C574.364 215.164 574.344 215.166 574.325 215.164C574.306 215.162 574.288 215.155 574.272 215.145C574.256 215.134 574.243 215.119 574.234 215.102C574.225 215.085 574.22 215.066 574.22 215.047C574.22 215.028 574.225 215.009 574.234 214.992C574.243 214.975 574.256 214.96 574.272 214.95C574.288 214.939 574.306 214.932 574.325 214.93C574.344 214.928 574.364 214.931 574.382 214.938C574.587 214.918 574.793 214.946 574.986 215.019C575.178 215.092 575.351 215.208 575.492 215.358C575.51 215.38 575.52 215.406 575.52 215.434C575.52 215.462 575.51 215.489 575.492 215.51C575.492 215.51 575.391 215.527 575.357 215.527Z",
    fill: "#263238"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M568.864 216.721C569.723 215.685 570.302 214.445 570.546 213.121C570.546 213.121 576.047 211.893 575.408 217.158C575.408 217.158 576.703 212.616 572.262 211.741C567.821 210.867 567.215 219.396 569.251 221.734C569.335 221.734 567.888 217.932 568.864 216.721Z",
    fill: "#263238"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M569.2 217.344C569.214 217.193 569.198 217.042 569.153 216.898C569.108 216.753 569.035 216.62 568.938 216.504C568.841 216.388 568.722 216.293 568.588 216.223C568.454 216.154 568.308 216.111 568.157 216.099C567.333 216.099 566.66 217.63 568.594 218.37C568.88 218.471 569.082 218.218 569.2 217.344Z",
    fill: "#FFB573"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M569.991 212.532C570.663 213.236 571.462 213.806 572.346 214.214C573.503 214.622 574.69 214.943 575.896 215.173C575.425 217.545 575.525 219.53 576.669 220.759C576.249 220.069 576.922 214.719 576.855 214.265C576.686 213.171 575.61 212.482 574.365 211.64C573.425 211.106 572.348 210.86 571.269 210.934L569.991 212.532Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M568.679 213.104V216.166C568.536 216.628 568.491 217.115 568.546 217.596C568.601 218.077 568.755 218.541 568.998 218.959C568.953 217.77 569.038 216.58 569.251 215.409L570.277 213.39L568.679 213.104Z",
    fill: "#263238"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M563.934 225.621C563.284 226.179 562.791 226.898 562.505 227.707C563.332 228.372 564.236 228.936 565.196 229.389L563.934 225.621Z",
    fill: "url(#paint38_linear_2280_9187)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M563.934 225.621C563.284 226.179 562.791 226.898 562.505 227.707C563.332 228.372 564.236 228.936 565.196 229.389L563.934 225.621Z",
    fill: "#1C262B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M577.612 224.207L578.285 228.161C579.201 227.484 580.026 226.693 580.741 225.806C579.844 225.025 578.77 224.476 577.612 224.207Z",
    fill: "url(#paint39_linear_2280_9187)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M577.612 224.207L578.285 228.161C579.201 227.484 580.026 226.693 580.741 225.806C579.844 225.025 578.77 224.476 577.612 224.207Z",
    fill: "#1C262B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M573.608 219.733H573.995C573.995 219.733 573.995 219.733 573.911 219.733C573.617 219.752 573.323 219.707 573.05 219.599C572.776 219.491 572.53 219.324 572.329 219.11C572.329 219.11 572.329 219.11 572.245 219.11C572.606 219.481 573.092 219.703 573.608 219.733Z",
    fill: "#263238"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M424.286 41.879H175.12V205.13H424.286V41.879Z",
    fill: "url(#paint40_linear_2280_9187)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.286 41.879H175.12V205.13H424.286V41.879Z",
    fill: "#1C262B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M239.553 64.9771H180.487V192.243H239.553V64.9771Z",
    fill: "url(#paint41_linear_2280_9187)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M239.553 64.9771H180.487V192.243H239.553V64.9771Z",
    fill: "#1C262B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M418.903 45.6473H180.487V57.9955H418.903V45.6473Z",
    fill: "url(#paint42_linear_2280_9187)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M418.903 45.6473H180.487V57.9955H418.903V45.6473Z",
    fill: "#1C262B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M418.903 64.9771H239.553V118.676H418.903V64.9771Z",
    fill: "url(#paint43_linear_2280_9187)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.903 64.9771H239.553V118.676H418.903V64.9771Z",
    fill: "#1C262B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M418.903 125.658H243.304V138.813H418.903V125.658Z",
    fill: "url(#paint44_linear_2280_9187)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M418.903 125.658H243.304V138.813H418.903V125.658Z",
    fill: "#1C262B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M418.903 146.064H243.304V192.243H418.903V146.064Z",
    fill: "url(#paint45_linear_2280_9187)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M418.903 146.064H243.304V192.243H418.903V146.064Z",
    fill: "#1C262B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M235.616 136.929H184.424V140.681H235.616V136.929Z",
    fill: "#658696"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M235.616 146.064H184.424V149.816H235.616V146.064Z",
    fill: "#658696"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M374.793 80.2355H323.601V83.9871H374.793V80.2355Z",
    fill: "#658696"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M374.793 87.7386H323.601V91.4902H374.793V87.7386Z",
    fill: "#658696"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M374.793 93.509H323.601V97.2605H374.793V93.509Z",
    fill: "#658696"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M235.616 155.182H184.424V158.934H235.616V155.182Z",
    fill: "#658696"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M235.616 164.317H184.424V168.069H235.616V164.317Z",
    fill: "#658696"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M415.522 130.284H246.719V134.17H415.522V130.284Z",
    fill: "#658696"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M389.379 158.951H272.845V162.837H389.379V158.951Z",
    fill: "#658696"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M389.379 167.211H272.845V171.097H389.379V167.211Z",
    fill: "#658696"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M389.379 175.471H272.845V179.357H389.379V175.471Z",
    fill: "#658696"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M401.357 49.1298H198.017V54.5132H401.357V49.1298Z",
    fill: "#658696"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M210.011 118.676C223.502 118.676 234.438 107.74 234.438 94.2491C234.438 80.7585 223.502 69.8221 210.011 69.8221C196.521 69.8221 185.584 80.7585 185.584 94.2491C185.584 107.74 196.521 118.676 210.011 118.676Z",
    fill: "#41525B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M231.377 298.178H244.65L241.1 336.164L270.86 339.31V341.951H206.529V339.31L226.952 336.164L231.377 298.178Z",
    fill: "#263238"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M231.377 298.178H244.65L241.1 336.164L270.86 339.31V341.951H206.529V339.31L226.952 336.164L231.377 298.178Z",
    fill: "#1C262B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M179.04 314.917H303.11C304.053 314.922 304.987 314.728 305.851 314.348C306.714 313.969 307.488 313.412 308.123 312.714C308.758 312.016 309.238 311.193 309.534 310.297C309.83 309.401 309.934 308.453 309.839 307.515L302.942 228.699C302.736 226.693 301.803 224.832 300.318 223.468C298.833 222.104 296.9 221.331 294.884 221.297H170.881C169.938 221.292 169.004 221.486 168.14 221.865C167.277 222.244 166.503 222.801 165.868 223.499C165.233 224.197 164.753 225.021 164.457 225.917C164.161 226.812 164.057 227.76 164.152 228.699L171.049 307.515C171.25 309.511 172.172 311.365 173.644 312.728C175.116 314.091 177.035 314.869 179.04 314.917Z",
    fill: "#263238"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M185.517 309.735H295.792C296.634 309.75 297.47 309.585 298.244 309.252C299.017 308.918 299.711 308.424 300.279 307.802C300.847 307.18 301.277 306.444 301.538 305.643C301.8 304.842 301.889 303.995 301.798 303.158L295.674 233.09C295.493 231.308 294.666 229.655 293.348 228.443C292.031 227.231 290.315 226.544 288.524 226.512H178.233C177.391 226.497 176.556 226.662 175.783 226.995C175.01 227.329 174.317 227.823 173.75 228.446C173.183 229.068 172.756 229.805 172.496 230.605C172.236 231.406 172.15 232.253 172.244 233.09L178.367 303.158C178.548 304.939 179.375 306.592 180.693 307.804C182.011 309.016 183.727 309.703 185.517 309.735Z",
    fill: "url(#paint46_linear_2280_9187)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M185.517 309.735H295.792C296.634 309.75 297.47 309.585 298.244 309.252C299.017 308.918 299.711 308.424 300.279 307.802C300.847 307.18 301.277 306.444 301.538 305.643C301.8 304.842 301.889 303.995 301.798 303.158L295.674 233.09C295.493 231.308 294.666 229.655 293.348 228.443C292.031 227.231 290.315 226.544 288.524 226.512H178.233C177.391 226.497 176.556 226.662 175.783 226.995C175.01 227.329 174.317 227.823 173.75 228.446C173.183 229.068 172.756 229.805 172.496 230.605C172.236 231.406 172.15 232.253 172.244 233.09L178.367 303.158C178.548 304.939 179.375 306.592 180.693 307.804C182.011 309.016 183.727 309.703 185.517 309.735Z",
    fill: "#1C262B"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M276.849 234.873H228.197L228.163 233.965H276.816L276.849 234.873Z",
    fill: "#1C262B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M277.59 237.649H244.162L244.128 236.74H277.556L277.59 237.649Z",
    fill: "#1C262B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M277.724 240.425H250.353L250.319 239.516H277.674L277.724 240.425Z",
    fill: "#1C262B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M278.145 243.2H242.614L242.581 242.292H278.094L278.145 243.2Z",
    fill: "#1C262B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M278.448 245.993H254.878L254.845 245.084H278.397L278.448 245.993Z",
    fill: "#1C262B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M279.474 254.455H230.821L230.788 253.547H279.423L279.474 254.455Z",
    fill: "#1C262B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M279.861 257.231H236.592L236.541 256.339H279.827L279.861 257.231Z",
    fill: "#1C262B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M280.332 260.023H252.977L252.944 259.115H280.298L280.332 260.023Z",
    fill: "#1C262B"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M280.601 262.799H245.087L245.054 261.891H280.567L280.601 262.799Z",
    fill: "#1C262B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M281.005 265.575H238.577L238.543 264.666H280.971L281.005 265.575Z",
    fill: "#1C262B"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M280.466 269.949H231.831L231.78 269.04H280.433L280.466 269.949Z",
    fill: "#1C262B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M281.223 272.725H247.779L247.745 271.833H281.173L281.223 272.725Z",
    fill: "#1C262B"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M281.341 275.517H253.987L253.936 274.609H281.291L281.341 275.517Z",
    fill: "#1C262B"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M281.762 278.293H246.231L246.198 277.385H281.711L281.762 278.293Z",
    fill: "#1C262B"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M282.064 281.069H258.495L258.462 280.161H282.014L282.064 281.069Z",
    fill: "#1C262B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M283.091 289.548H234.455L234.405 288.639H283.057L283.091 289.548Z",
    fill: "#1C262B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M283.494 292.324H240.209L240.158 291.415H283.444L283.494 292.324Z",
    fill: "#1C262B"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M283.965 295.099H256.594L256.561 294.191H283.915L283.965 295.099Z",
    fill: "#1C262B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M284.235 297.875H248.704L248.671 296.967H284.184L284.235 297.875Z",
    fill: "#1C262B"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M284.621 300.651H242.194L242.16 299.743H284.588L284.621 300.651Z",
    fill: "#1C262B"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M212.686 248.769H196.031C195.017 248.765 194.04 248.384 193.291 247.7C192.541 247.016 192.073 246.078 191.977 245.068L191.254 236.959C191.205 236.397 191.273 235.831 191.455 235.296C191.636 234.762 191.927 234.271 192.308 233.855C192.689 233.439 193.153 233.107 193.669 232.88C194.186 232.652 194.744 232.535 195.308 232.535H211.963C212.979 232.535 213.958 232.914 214.708 233.599C215.458 234.284 215.925 235.224 216.017 236.236L216.741 244.327C216.792 244.891 216.725 245.459 216.545 245.995C216.365 246.532 216.074 247.025 215.693 247.442C215.312 247.86 214.847 248.194 214.329 248.422C213.812 248.651 213.252 248.769 212.686 248.769Z",
    fill: "url(#paint47_linear_2280_9187)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M212.686 248.769H196.031C195.017 248.765 194.04 248.384 193.291 247.7C192.541 247.016 192.073 246.078 191.977 245.068L191.254 236.959C191.205 236.397 191.273 235.831 191.455 235.296C191.636 234.762 191.927 234.271 192.308 233.855C192.689 233.439 193.153 233.107 193.669 232.88C194.186 232.652 194.744 232.535 195.308 232.535H211.963C212.979 232.535 213.958 232.914 214.708 233.599C215.458 234.284 215.925 235.224 216.017 236.236L216.741 244.327C216.792 244.891 216.725 245.459 216.545 245.995C216.365 246.532 216.074 247.025 215.693 247.442C215.312 247.86 214.847 248.194 214.329 248.422C213.812 248.651 213.252 248.769 212.686 248.769Z",
    fill: "url(#paint48_linear_2280_9187)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M211.761 247.961H196.923C195.905 247.961 194.923 247.579 194.173 246.891C193.422 246.202 192.957 245.258 192.869 244.243L192.482 240.004C192.433 239.442 192.501 238.876 192.683 238.341C192.864 237.807 193.155 237.316 193.536 236.9C193.917 236.484 194.381 236.152 194.897 235.925C195.414 235.697 195.972 235.58 196.536 235.58H211.374C212.39 235.58 213.369 235.959 214.119 236.644C214.869 237.329 215.336 238.269 215.428 239.281L215.798 243.52C215.852 244.083 215.788 244.65 215.61 245.187C215.431 245.723 215.143 246.216 214.763 246.634C214.382 247.052 213.919 247.387 213.402 247.615C212.885 247.844 212.326 247.962 211.761 247.961Z",
    fill: "#263238"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M211.189 237.767H200.321L200.304 237.43H211.155L211.189 237.767Z",
    fill: "#1C262B"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M205.637 238.809H200.422L200.389 238.473H205.604L205.637 238.809Z",
    fill: "#1C262B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M207.084 239.853H200.523L200.489 239.5H207.05L207.084 239.853Z",
    fill: "#1C262B"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M202.929 240.896H200.607L200.574 240.542H202.895L202.929 240.896Z",
    fill: "#1C262B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M202.205 241.939H200.708L200.675 241.585H202.172L202.205 241.939Z",
    fill: "#1C262B"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M211.896 242.914H201.028L201.011 242.561H211.879L211.896 242.914Z",
    fill: "#1C262B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M206.344 243.958H201.129L201.095 243.604H206.31L206.344 243.958Z",
    fill: "#1C262B"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M207.791 244.983H201.23L201.196 244.647H207.757L207.791 244.983Z",
    fill: "#1C262B"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M203.635 246.027H201.314L201.28 245.69H203.602L203.635 246.027Z",
    fill: "#1C262B"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M202.912 247.07H201.415L201.381 246.733H202.878L202.912 247.07Z",
    fill: "#1C262B"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M199.059 246.229H195.695C195.343 246.231 195.003 246.104 194.739 245.871C194.475 245.638 194.306 245.316 194.265 244.967L193.592 239.012C193.571 238.811 193.592 238.609 193.654 238.418C193.716 238.226 193.818 238.05 193.953 237.901C194.088 237.752 194.253 237.633 194.437 237.552C194.622 237.47 194.821 237.429 195.022 237.43H198.387C198.738 237.428 199.079 237.555 199.343 237.788C199.606 238.021 199.775 238.343 199.817 238.692L200.489 244.647C200.511 244.847 200.49 245.05 200.427 245.241C200.365 245.432 200.263 245.609 200.128 245.758C199.993 245.907 199.828 246.026 199.644 246.107C199.46 246.188 199.261 246.23 199.059 246.229Z",
    fill: "#1C262B"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M194.837 245.808H200.103L199.85 243.924C199.292 243.417 198.569 243.13 197.815 243.116C198.197 242.973 198.525 242.715 198.754 242.378C198.983 242.04 199.102 241.64 199.093 241.232C198.959 239.852 198.488 238.608 197.091 238.608C195.695 238.608 195.409 239.937 195.409 241.232C195.431 241.626 195.552 242.008 195.761 242.343C195.97 242.679 196.26 242.956 196.603 243.15C196.234 243.083 195.854 243.117 195.502 243.247C195.149 243.377 194.839 243.599 194.601 243.89L194.837 245.808Z",
    fill: "#263238"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M214.84 266.265H197.243C196.344 266.264 195.477 265.927 194.814 265.32C194.151 264.713 193.739 263.88 193.659 262.984L192.852 253.934C192.808 253.438 192.867 252.939 193.026 252.468C193.185 251.997 193.44 251.564 193.776 251.197C194.111 250.83 194.519 250.536 194.974 250.336C195.429 250.135 195.921 250.031 196.418 250.031H214.032C214.928 250.031 215.793 250.366 216.455 250.969C217.118 251.573 217.532 252.402 217.615 253.294L218.423 262.345C218.467 262.843 218.408 263.344 218.248 263.817C218.088 264.29 217.831 264.725 217.494 265.094C217.157 265.462 216.747 265.757 216.29 265.959C215.833 266.16 215.339 266.265 214.84 266.265Z",
    fill: "url(#paint49_linear_2280_9187)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M214.84 266.265H197.243C196.344 266.264 195.477 265.927 194.814 265.32C194.151 264.713 193.739 263.88 193.659 262.984L192.852 253.934C192.808 253.438 192.867 252.939 193.026 252.468C193.185 251.997 193.44 251.564 193.776 251.197C194.111 250.83 194.519 250.536 194.974 250.336C195.429 250.135 195.921 250.031 196.418 250.031H214.032C214.928 250.031 215.793 250.366 216.455 250.969C217.118 251.573 217.532 252.402 217.615 253.294L218.423 262.345C218.467 262.843 218.408 263.344 218.248 263.817C218.088 264.29 217.831 264.725 217.494 265.094C217.157 265.462 216.747 265.757 216.29 265.959C215.833 266.16 215.339 266.265 214.84 266.265Z",
    fill: "url(#paint50_linear_2280_9187)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M213.864 265.441H198.067C197.172 265.44 196.31 265.105 195.65 264.501C194.991 263.897 194.58 263.068 194.501 262.177L194.029 256.979C193.985 256.482 194.045 255.981 194.205 255.509C194.365 255.037 194.622 254.603 194.959 254.235C195.296 253.868 195.706 253.575 196.163 253.375C196.62 253.176 197.114 253.074 197.613 253.076H213.393C214.29 253.072 215.156 253.405 215.82 254.01C216.483 254.614 216.896 255.445 216.976 256.339L217.447 261.538C217.489 262.034 217.428 262.533 217.267 263.004C217.106 263.476 216.849 263.908 216.512 264.275C216.175 264.642 215.766 264.935 215.31 265.135C214.854 265.336 214.362 265.44 213.864 265.441Z",
    fill: "#263238"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M212.787 255.262H201.919L201.886 254.909H212.753L212.787 255.262Z",
    fill: "#1C262B"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M207.219 256.306H202.004L201.97 255.952H207.185L207.219 256.306Z",
    fill: "#1C262B"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M208.665 257.348H202.105L202.071 256.995H208.632L208.665 257.348Z",
    fill: "#1C262B"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M204.51 258.375H202.189L202.172 258.038H204.477L204.51 258.375Z",
    fill: "#1C262B"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M203.787 259.418H202.29L202.256 259.081H203.753L203.787 259.418Z",
    fill: "#1C262B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M213.494 260.41H202.626L202.592 260.057H213.46L213.494 260.41Z",
    fill: "#1C262B"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M207.925 261.436H202.71L202.693 261.1H207.892L207.925 261.436Z",
    fill: "#1C262B"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M209.372 262.48H202.811L202.777 262.143H209.338L209.372 262.48Z",
    fill: "#1C262B"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M205.217 263.523H202.895L202.878 263.186H205.183L205.217 263.523Z",
    fill: "#1C262B"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M204.493 264.565H202.996L202.963 264.229H204.46L204.493 264.565Z",
    fill: "#1C262B"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M200.018 263.724H197.882C197.387 263.727 196.908 263.547 196.538 263.217C196.169 262.888 195.934 262.433 195.88 261.941L195.342 257.146C195.308 256.867 195.335 256.583 195.419 256.314C195.504 256.046 195.645 255.798 195.833 255.588C196.021 255.378 196.251 255.21 196.508 255.096C196.766 254.982 197.045 254.924 197.327 254.926H199.463C199.956 254.922 200.432 255.101 200.802 255.427C201.171 255.752 201.407 256.203 201.465 256.692L202.004 261.504C202.034 261.783 202.006 262.065 201.92 262.333C201.834 262.601 201.693 262.847 201.506 263.057C201.319 263.266 201.09 263.434 200.833 263.549C200.577 263.664 200.299 263.724 200.018 263.724Z",
    fill: "#1C262B"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M196.418 263.337H201.684L201.432 261.453C200.878 260.95 200.161 260.664 199.413 260.646C199.795 260.504 200.122 260.246 200.349 259.908C200.575 259.57 200.689 259.168 200.675 258.762C200.557 257.382 200.069 256.137 198.673 256.137C197.276 256.137 196.99 257.466 196.99 258.762C197.013 259.156 197.134 259.538 197.343 259.873C197.551 260.208 197.841 260.485 198.185 260.679C197.344 260.427 196.755 260.932 196.183 261.42L196.418 263.337Z",
    fill: "#263238"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M216.421 284.164H198.874C197.961 284.158 197.084 283.809 196.417 283.186C195.75 282.562 195.342 281.71 195.274 280.8L194.467 271.816C194.42 271.316 194.478 270.811 194.638 270.335C194.798 269.859 195.055 269.421 195.395 269.05C195.734 268.679 196.147 268.384 196.607 268.182C197.067 267.981 197.564 267.877 198.067 267.88H215.613C216.531 267.877 217.414 268.224 218.086 268.848C218.757 269.473 219.166 270.329 219.23 271.244L220.021 280.228C220.065 280.728 220.005 281.231 219.845 281.706C219.684 282.182 219.426 282.618 219.087 282.988C218.749 283.359 218.337 283.654 217.878 283.857C217.419 284.059 216.923 284.164 216.421 284.164Z",
    fill: "url(#paint51_linear_2280_9187)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M216.421 284.164H198.874C197.961 284.158 197.084 283.809 196.417 283.186C195.75 282.562 195.342 281.71 195.274 280.8L194.467 271.816C194.42 271.316 194.478 270.811 194.638 270.335C194.798 269.859 195.055 269.421 195.395 269.05C195.734 268.679 196.147 268.384 196.607 268.182C197.067 267.981 197.564 267.877 198.067 267.88H215.613C216.531 267.877 217.414 268.224 218.086 268.848C218.757 269.473 219.166 270.329 219.23 271.244L220.021 280.228C220.065 280.728 220.005 281.231 219.845 281.706C219.684 282.182 219.426 282.618 219.087 282.988C218.749 283.359 218.337 283.654 217.878 283.857C217.419 284.059 216.923 284.164 216.421 284.164Z",
    fill: "url(#paint52_linear_2280_9187)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M215.445 283.34H199.716C198.799 283.343 197.915 282.996 197.243 282.372C196.572 281.747 196.163 280.891 196.099 279.976L195.644 274.929C195.61 274.435 195.677 273.94 195.841 273.472C196.005 273.005 196.262 272.577 196.598 272.213C196.934 271.849 197.34 271.558 197.792 271.356C198.244 271.155 198.733 271.048 199.228 271.043H214.957C215.873 271.044 216.755 271.392 217.425 272.016C218.096 272.64 218.506 273.494 218.574 274.407L219.028 279.538C219.056 280.026 218.984 280.515 218.816 280.974C218.649 281.433 218.389 281.854 218.054 282.209C217.719 282.565 217.314 282.849 216.866 283.043C216.417 283.238 215.934 283.339 215.445 283.34Z",
    fill: "#263238"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M214.402 273.162H203.534L203.501 272.809H214.368L214.402 273.162Z",
    fill: "#1C262B"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M208.834 274.205H203.619L203.585 273.852H208.8L208.834 274.205Z",
    fill: "#1C262B"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M210.28 275.248H203.719L203.686 274.895H210.247L210.28 275.248Z",
    fill: "#1C262B"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M206.125 276.274H203.804L203.77 275.938H206.092L206.125 276.274Z",
    fill: "#1C262B"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M205.402 277.318H203.905L203.871 276.981H205.368L205.402 277.318Z",
    fill: "#1C262B"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M215.109 278.293H204.224L204.207 277.957H215.075L215.109 278.293Z",
    fill: "#1C262B"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M209.54 279.336H204.325L204.292 279H209.507L209.54 279.336Z",
    fill: "#1C262B"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M210.987 280.379H204.426L204.392 280.043H210.953L210.987 280.379Z",
    fill: "#1C262B"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M206.832 281.422H204.51L204.477 281.086H206.798L206.832 281.422Z",
    fill: "#1C262B"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M206.108 282.465H204.611L204.578 282.129H206.075L206.108 282.465Z",
    fill: "#1C262B"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M201.785 281.624H199.346C198.884 281.626 198.439 281.454 198.1 281.142C197.76 280.83 197.55 280.402 197.512 279.942L196.923 274.895C196.895 274.635 196.921 274.372 197.001 274.122C197.081 273.873 197.213 273.643 197.387 273.448C197.562 273.253 197.776 273.097 198.014 272.99C198.253 272.882 198.512 272.827 198.774 272.826H201.213C201.674 272.831 202.116 273.006 202.457 273.316C202.798 273.626 203.014 274.05 203.063 274.508L203.635 279.555C203.664 279.815 203.637 280.079 203.557 280.328C203.477 280.577 203.345 280.807 203.171 281.002C202.996 281.197 202.783 281.353 202.544 281.46C202.305 281.568 202.047 281.623 201.785 281.624Z",
    fill: "#1C262B"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M198.033 281.237H203.299L203.047 279.353C202.488 278.846 201.765 278.559 201.011 278.546C201.397 278.404 201.729 278.144 201.959 277.802C202.188 277.461 202.304 277.056 202.29 276.645C202.155 275.282 201.684 274.02 200.288 274.02C198.891 274.02 198.605 275.366 198.605 276.645C198.625 277.042 198.745 277.427 198.954 277.766C199.163 278.104 199.454 278.384 199.8 278.579C198.959 278.327 198.37 278.832 197.798 279.303L198.033 281.237Z",
    fill: "#263238"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M218.642 301.643H199.934C199.174 301.642 198.442 301.357 197.882 300.843C197.321 300.329 196.973 299.625 196.906 298.868L195.998 288.774C195.953 288.349 195.998 287.92 196.13 287.514C196.261 287.108 196.477 286.734 196.763 286.417C197.048 286.1 197.397 285.846 197.787 285.673C198.177 285.499 198.599 285.409 199.026 285.409H217.733C218.498 285.41 219.234 285.698 219.798 286.214C220.361 286.731 220.711 287.44 220.778 288.202L221.687 298.296C221.729 298.72 221.682 299.149 221.548 299.554C221.414 299.959 221.196 300.332 220.909 300.647C220.622 300.963 220.272 301.215 219.881 301.386C219.491 301.558 219.068 301.646 218.642 301.643Z",
    fill: "url(#paint53_linear_2280_9187)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M218.642 301.643H199.934C199.174 301.642 198.442 301.357 197.882 300.843C197.321 300.329 196.973 299.625 196.906 298.868L195.998 288.774C195.953 288.349 195.998 287.92 196.13 287.514C196.261 287.108 196.477 286.734 196.763 286.417C197.048 286.1 197.397 285.846 197.787 285.673C198.177 285.499 198.599 285.409 199.026 285.409H217.733C218.498 285.41 219.234 285.698 219.798 286.214C220.361 286.731 220.711 287.44 220.778 288.202L221.687 298.296C221.729 298.72 221.682 299.149 221.548 299.554C221.414 299.959 221.196 300.332 220.909 300.647C220.622 300.963 220.272 301.215 219.881 301.386C219.491 301.558 219.068 301.646 218.642 301.643Z",
    fill: "url(#paint54_linear_2280_9187)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M217.733 300.836H200.91C200.148 300.835 199.414 300.55 198.851 300.037C198.288 299.524 197.936 298.819 197.865 298.06L197.31 291.785C197.268 291.36 197.315 290.93 197.449 290.524C197.582 290.118 197.8 289.745 198.087 289.428C198.373 289.111 198.723 288.858 199.114 288.684C199.505 288.511 199.927 288.421 200.355 288.421H217.178C217.938 288.422 218.67 288.707 219.231 289.221C219.791 289.735 220.139 290.439 220.206 291.196L220.778 297.488C220.821 297.913 220.773 298.342 220.639 298.747C220.505 299.152 220.288 299.524 220.001 299.84C219.714 300.156 219.363 300.407 218.973 300.579C218.582 300.751 218.16 300.838 217.733 300.836Z",
    fill: "#263238"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M215.984 290.658H205.116L205.082 290.305H215.95L215.984 290.658Z",
    fill: "#1C262B"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M210.415 291.684H205.2L205.166 291.348H210.398L210.415 291.684Z",
    fill: "#1C262B"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M211.862 292.727H205.301L205.267 292.391H211.845L211.862 292.727Z",
    fill: "#1C262B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M207.707 293.77H205.402L205.368 293.434H207.673L207.707 293.77Z",
    fill: "#1C262B"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M206.983 294.814H205.486L205.452 294.477H206.95L206.983 294.814Z",
    fill: "#1C262B"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M216.69 295.789H205.822L205.789 295.453H216.656L216.69 295.789Z",
    fill: "#1C262B"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M211.122 296.832H205.906L205.89 296.496H211.105L211.122 296.832Z",
    fill: "#1C262B"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M212.568 297.875H206.007L205.974 297.539H212.552L212.568 297.875Z",
    fill: "#1C262B"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M208.413 298.918H206.092L206.075 298.582H208.379L208.413 298.918Z",
    fill: "#1C262B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M207.69 299.961H206.192L206.159 299.625H207.656L207.69 299.961Z",
    fill: "#1C262B"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 299.12H201.129C200.621 299.119 200.132 298.932 199.753 298.594C199.375 298.256 199.134 297.791 199.076 297.286L198.538 292.61C198.507 292.319 198.538 292.026 198.628 291.748C198.718 291.47 198.865 291.215 199.06 290.997C199.255 290.78 199.494 290.606 199.76 290.487C200.027 290.368 200.315 290.306 200.607 290.305H202.592C203.101 290.302 203.592 290.488 203.971 290.827C204.351 291.165 204.591 291.633 204.645 292.139L205.183 296.815C205.216 297.103 205.188 297.395 205.101 297.672C205.014 297.948 204.87 298.203 204.678 298.421C204.486 298.638 204.251 298.813 203.987 298.933C203.723 299.054 203.437 299.117 203.148 299.12Z",
    fill: "#1C262B"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M199.632 298.733H204.88L204.628 296.849C204.076 296.34 203.36 296.047 202.609 296.025C202.993 295.886 203.321 295.628 203.548 295.289C203.775 294.95 203.888 294.548 203.871 294.141C203.753 292.778 203.265 291.516 201.869 291.516C200.473 291.516 200.187 292.862 200.187 294.141C200.208 294.539 200.33 294.926 200.542 295.265C200.754 295.603 201.049 295.882 201.398 296.075C201.028 296.005 200.645 296.036 200.29 296.163C199.935 296.29 199.621 296.509 199.379 296.799L199.632 298.733Z",
    fill: "#263238"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M381.219 298.06H394.695L391.095 336.618L421.309 339.815V342.49H356.002V339.815L376.728 336.618L381.219 298.06Z",
    fill: "#263238"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M381.219 298.06H394.695L391.095 336.618L421.309 339.815V342.49H356.002V339.815L376.728 336.618L381.219 298.06Z",
    fill: "#1C262B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M328.126 315.035H454.097C455.061 315.058 456.019 314.874 456.906 314.495C457.793 314.116 458.588 313.551 459.237 312.838C459.886 312.125 460.375 311.28 460.669 310.362C460.964 309.443 461.057 308.472 460.944 307.515L453.945 227.504C453.729 225.471 452.78 223.587 451.275 222.203C449.771 220.819 447.813 220.03 445.769 219.984H319.815C318.85 219.958 317.89 220.14 317.001 220.518C316.112 220.896 315.315 221.461 314.664 222.175C314.013 222.888 313.523 223.733 313.227 224.653C312.932 225.573 312.838 226.545 312.952 227.504L319.95 307.515C320.166 309.548 321.115 311.432 322.62 312.816C324.125 314.2 326.082 314.989 328.126 315.035Z",
    fill: "#263238"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M334.67 309.735H446.627C447.487 309.751 448.34 309.582 449.129 309.24C449.918 308.899 450.625 308.392 451.202 307.755C451.779 307.117 452.213 306.364 452.474 305.544C452.735 304.725 452.818 303.86 452.717 303.006L446.526 231.945C446.354 230.13 445.519 228.441 444.182 227.2C442.845 225.959 441.099 225.253 439.276 225.216H327.268C326.408 225.201 325.555 225.369 324.766 225.711C323.977 226.053 323.27 226.559 322.693 227.197C322.117 227.834 321.683 228.588 321.421 229.407C321.16 230.226 321.077 231.092 321.178 231.945L327.403 303.073C327.591 304.88 328.435 306.555 329.773 307.782C331.112 309.009 332.854 309.704 334.67 309.735Z",
    fill: "url(#paint55_linear_2280_9187)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M334.67 309.735H446.627C447.487 309.751 448.34 309.582 449.129 309.24C449.918 308.899 450.625 308.392 451.202 307.755C451.779 307.117 452.213 306.364 452.474 305.544C452.735 304.725 452.818 303.86 452.717 303.006L446.526 231.945C446.354 230.13 445.519 228.441 444.182 227.2C442.845 225.959 441.099 225.253 439.276 225.216H327.268C326.408 225.201 325.555 225.369 324.766 225.711C323.977 226.053 323.27 226.559 322.693 227.197C322.117 227.834 321.683 228.588 321.421 229.407C321.16 230.226 321.077 231.092 321.178 231.945L327.403 303.073C327.591 304.88 328.435 306.555 329.773 307.782C331.112 309.009 332.854 309.704 334.67 309.735Z",
    fill: "#1C262B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M367.711 290.103L357.936 246.363C357.895 246.172 357.802 245.997 357.666 245.856C357.531 245.716 357.359 245.617 357.169 245.57C356.98 245.522 356.782 245.529 356.596 245.589C356.41 245.649 356.245 245.76 356.119 245.909L346.261 257.247C346.136 257.392 345.973 257.499 345.791 257.557C345.609 257.615 345.414 257.621 345.228 257.576C345.042 257.531 344.872 257.436 344.737 257.301C344.602 257.165 344.506 256.996 344.461 256.81L342.981 251.208C342.924 250.994 342.801 250.803 342.63 250.664C342.458 250.524 342.246 250.443 342.025 250.432C341.804 250.421 341.585 250.48 341.4 250.601C341.215 250.723 341.073 250.9 340.996 251.107L332.988 272.287C332.939 272.415 332.866 272.533 332.772 272.633C332.678 272.732 332.565 272.813 332.44 272.869C332.315 272.925 332.181 272.956 332.044 272.96C331.907 272.964 331.77 272.941 331.642 272.893C331.512 272.846 331.394 272.774 331.292 272.68C331.191 272.587 331.11 272.474 331.054 272.348C330.997 272.223 330.966 272.087 330.963 271.949C330.961 271.812 330.985 271.675 331.036 271.547L341.349 244.125C341.428 243.919 341.571 243.742 341.757 243.622C341.944 243.502 342.163 243.444 342.385 243.458C342.606 243.471 342.817 243.554 342.988 243.695C343.158 243.836 343.28 244.028 343.334 244.243L345.47 252.352C345.521 252.536 345.621 252.703 345.758 252.836C345.896 252.968 346.067 253.061 346.254 253.104C346.44 253.147 346.634 253.139 346.816 253.081C346.998 253.022 347.161 252.916 347.287 252.772L357.263 241.299C357.387 241.149 357.551 241.037 357.736 240.976C357.92 240.915 358.119 240.908 358.307 240.955C358.496 241.003 358.667 241.103 358.801 241.245C358.935 241.386 359.026 241.562 359.063 241.753L368.131 282.314C368.177 282.541 368.297 282.746 368.473 282.897C368.649 283.048 368.87 283.137 369.101 283.148C369.333 283.16 369.561 283.094 369.751 282.961C369.941 282.828 370.081 282.636 370.15 282.415L383.154 244.159C383.219 243.961 383.343 243.787 383.508 243.659C383.673 243.532 383.873 243.457 384.081 243.444C384.29 243.431 384.497 243.481 384.677 243.588C384.856 243.694 385 243.852 385.089 244.041L389.109 252.301C389.194 252.48 389.328 252.63 389.494 252.735C389.661 252.841 389.854 252.897 390.052 252.897C390.249 252.897 390.442 252.841 390.609 252.735C390.776 252.63 390.909 252.48 390.994 252.301L399.843 232.787C399.935 232.589 400.087 232.426 400.276 232.317C400.465 232.209 400.683 232.162 400.9 232.182C401.117 232.203 401.323 232.289 401.489 232.43C401.655 232.572 401.773 232.761 401.828 232.972L412.157 275.029C412.205 275.233 412.312 275.417 412.466 275.559C412.619 275.7 412.812 275.793 413.019 275.824C413.225 275.854 413.437 275.822 413.625 275.732C413.813 275.641 413.97 275.496 414.075 275.315L440.874 229.338C440.942 229.218 441.033 229.113 441.142 229.029C441.251 228.944 441.375 228.882 441.508 228.847C441.641 228.811 441.78 228.801 441.917 228.819C442.053 228.837 442.185 228.882 442.304 228.951C442.424 229.019 442.529 229.11 442.613 229.219C442.697 229.329 442.758 229.454 442.793 229.587C442.827 229.721 442.834 229.86 442.814 229.996C442.794 230.133 442.746 230.263 442.674 230.381L413.284 280.85C413.179 281.031 413.023 281.176 412.834 281.267C412.646 281.357 412.435 281.389 412.228 281.358C412.021 281.327 411.829 281.235 411.675 281.094C411.521 280.952 411.414 280.768 411.366 280.564L401.273 239.297C401.222 239.085 401.107 238.893 400.942 238.75C400.778 238.606 400.572 238.518 400.355 238.498C400.137 238.477 399.919 238.525 399.731 238.636C399.542 238.746 399.393 238.913 399.304 239.112L391.01 257.247C390.926 257.426 390.792 257.576 390.626 257.681C390.459 257.787 390.266 257.843 390.068 257.843C389.871 257.843 389.678 257.787 389.511 257.681C389.344 257.576 389.211 257.426 389.126 257.247L385.375 249.559C385.286 249.37 385.142 249.212 384.963 249.106C384.783 248.999 384.576 248.949 384.367 248.962C384.159 248.975 383.959 249.05 383.794 249.177C383.629 249.305 383.505 249.479 383.44 249.677L369.679 290.17C369.601 290.372 369.461 290.544 369.281 290.663C369.1 290.783 368.887 290.843 368.671 290.835C368.455 290.828 368.246 290.753 368.074 290.622C367.902 290.491 367.775 290.309 367.711 290.103Z",
    fill: "#263238"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M331.894 294.813H440.184C441.188 294.813 442.001 294 442.001 292.996V292.626C442.001 291.623 441.188 290.809 440.184 290.809H331.894C330.891 290.809 330.077 291.623 330.077 292.626V292.996C330.077 294 330.891 294.813 331.894 294.813Z",
    fill: "url(#paint56_linear_2280_9187)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M437.661 299.204C437.661 299.66 437.796 300.105 438.049 300.485C438.302 300.864 438.662 301.159 439.083 301.333C439.505 301.508 439.968 301.553 440.415 301.465C440.862 301.376 441.273 301.156 441.595 300.834C441.918 300.511 442.137 300.101 442.226 299.654C442.315 299.207 442.269 298.743 442.095 298.322C441.92 297.901 441.625 297.541 441.246 297.288C440.867 297.034 440.421 296.899 439.966 296.899C439.356 296.904 438.772 297.148 438.341 297.579C437.909 298.01 437.665 298.594 437.661 299.204Z",
    fill: "#263238"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M421.78 299.608H434.515C434.775 299.608 434.986 299.397 434.986 299.137V299.019C434.986 298.759 434.775 298.548 434.515 298.548H421.78C421.52 298.548 421.309 298.759 421.309 299.019V299.137C421.309 299.397 421.52 299.608 421.78 299.608Z",
    fill: "#263238"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M421.78 299.608H434.515C434.775 299.608 434.986 299.397 434.986 299.137V299.019C434.986 298.759 434.775 298.548 434.515 298.548H421.78C421.52 298.548 421.309 298.759 421.309 299.019V299.137C421.309 299.397 421.52 299.608 421.78 299.608Z",
    fill: "#1C262B"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M421.78 302.031H434.515C434.775 302.031 434.986 301.82 434.986 301.56V301.442C434.986 301.182 434.775 300.971 434.515 300.971H421.78C421.52 300.971 421.309 301.182 421.309 301.442V301.56C421.309 301.82 421.52 302.031 421.78 302.031Z",
    fill: "#263238"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M421.78 302.031H434.515C434.775 302.031 434.986 301.82 434.986 301.56V301.442C434.986 301.182 434.775 300.971 434.515 300.971H421.78C421.52 300.971 421.309 301.182 421.309 301.442V301.56C421.309 301.82 421.52 302.031 421.78 302.031Z",
    fill: "#1C262B"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M421.78 304.453H434.515C434.775 304.453 434.986 304.242 434.986 303.982V303.864C434.986 303.604 434.775 303.393 434.515 303.393H421.78C421.52 303.393 421.309 303.604 421.309 303.864V303.982C421.309 304.242 421.52 304.453 421.78 304.453Z",
    fill: "#263238"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M421.78 304.453H434.515C434.775 304.453 434.986 304.242 434.986 303.982V303.864C434.986 303.604 434.775 303.393 434.515 303.393H421.78C421.52 303.393 421.309 303.604 421.309 303.864V303.982C421.309 304.242 421.52 304.453 421.78 304.453Z",
    fill: "#1C262B"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 299.204C409.364 299.66 409.5 300.105 409.753 300.485C410.006 300.864 410.366 301.159 410.787 301.333C411.208 301.508 411.672 301.553 412.119 301.465C412.566 301.376 412.977 301.156 413.299 300.834C413.621 300.511 413.841 300.101 413.93 299.654C414.019 299.207 413.973 298.743 413.799 298.322C413.624 297.901 413.329 297.541 412.95 297.288C412.571 297.034 412.125 296.899 411.669 296.899C411.059 296.904 410.476 297.148 410.044 297.579C409.613 298.01 409.369 298.594 409.364 299.204Z",
    fill: "#263238"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M393.483 299.608H406.218C406.479 299.608 406.69 299.397 406.69 299.137V299.019C406.69 298.759 406.479 298.548 406.218 298.548H393.483C393.223 298.548 393.012 298.759 393.012 299.019V299.137C393.012 299.397 393.223 299.608 393.483 299.608Z",
    fill: "#263238"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.483 299.608H406.218C406.479 299.608 406.69 299.397 406.69 299.137V299.019C406.69 298.759 406.479 298.548 406.218 298.548H393.483C393.223 298.548 393.012 298.759 393.012 299.019V299.137C393.012 299.397 393.223 299.608 393.483 299.608Z",
    fill: "#1C262B"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M393.483 302.031H406.218C406.479 302.031 406.69 301.82 406.69 301.56V301.442C406.69 301.182 406.479 300.971 406.218 300.971H393.483C393.223 300.971 393.012 301.182 393.012 301.442V301.56C393.012 301.82 393.223 302.031 393.483 302.031Z",
    fill: "#263238"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.483 302.031H406.218C406.479 302.031 406.69 301.82 406.69 301.56V301.442C406.69 301.182 406.479 300.971 406.218 300.971H393.483C393.223 300.971 393.012 301.182 393.012 301.442V301.56C393.012 301.82 393.223 302.031 393.483 302.031Z",
    fill: "#1C262B"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M393.483 304.453H406.218C406.479 304.453 406.69 304.242 406.69 303.982V303.864C406.69 303.604 406.479 303.393 406.218 303.393H393.483C393.223 303.393 393.012 303.604 393.012 303.864V303.982C393.012 304.242 393.223 304.453 393.483 304.453Z",
    fill: "#263238"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.483 304.453H406.218C406.479 304.453 406.69 304.242 406.69 303.982V303.864C406.69 303.604 406.479 303.393 406.218 303.393H393.483C393.223 303.393 393.012 303.604 393.012 303.864V303.982C393.012 304.242 393.223 304.453 393.483 304.453Z",
    fill: "#1C262B"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M381.421 299.204C381.421 299.66 381.557 300.105 381.81 300.485C382.063 300.864 382.423 301.159 382.844 301.333C383.265 301.508 383.729 301.553 384.176 301.465C384.623 301.376 385.034 301.156 385.356 300.834C385.678 300.511 385.898 300.101 385.987 299.654C386.076 299.207 386.03 298.743 385.855 298.322C385.681 297.901 385.386 297.541 385.007 297.288C384.628 297.034 384.182 296.899 383.726 296.899C383.116 296.904 382.533 297.148 382.101 297.579C381.67 298.01 381.426 298.594 381.421 299.204Z",
    fill: "#263238"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M365.54 299.608H378.275C378.536 299.608 378.746 299.397 378.746 299.137V299.019C378.746 298.759 378.536 298.548 378.275 298.548H365.54C365.28 298.548 365.069 298.759 365.069 299.019V299.137C365.069 299.397 365.28 299.608 365.54 299.608Z",
    fill: "#263238"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.54 299.608H378.275C378.536 299.608 378.746 299.397 378.746 299.137V299.019C378.746 298.759 378.536 298.548 378.275 298.548H365.54C365.28 298.548 365.069 298.759 365.069 299.019V299.137C365.069 299.397 365.28 299.608 365.54 299.608Z",
    fill: "#1C262B"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M365.54 302.031H378.275C378.536 302.031 378.746 301.82 378.746 301.56V301.442C378.746 301.182 378.536 300.971 378.275 300.971H365.54C365.28 300.971 365.069 301.182 365.069 301.442V301.56C365.069 301.82 365.28 302.031 365.54 302.031Z",
    fill: "#263238"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.54 302.031H378.275C378.536 302.031 378.746 301.82 378.746 301.56V301.442C378.746 301.182 378.536 300.971 378.275 300.971H365.54C365.28 300.971 365.069 301.182 365.069 301.442V301.56C365.069 301.82 365.28 302.031 365.54 302.031Z",
    fill: "#1C262B"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M365.54 304.453H378.275C378.536 304.453 378.746 304.242 378.746 303.982V303.864C378.746 303.604 378.536 303.393 378.275 303.393H365.54C365.28 303.393 365.069 303.604 365.069 303.864V303.982C365.069 304.242 365.28 304.453 365.54 304.453Z",
    fill: "#263238"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.54 304.453H378.275C378.536 304.453 378.746 304.242 378.746 303.982V303.864C378.746 303.604 378.536 303.393 378.275 303.393H365.54C365.28 303.393 365.069 303.604 365.069 303.864V303.982C365.069 304.242 365.28 304.453 365.54 304.453Z",
    fill: "#1C262B"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M352.839 299.204C352.839 299.66 352.974 300.105 353.227 300.485C353.481 300.864 353.841 301.159 354.262 301.333C354.683 301.508 355.146 301.553 355.593 301.465C356.04 301.376 356.451 301.156 356.773 300.834C357.096 300.511 357.315 300.101 357.404 299.654C357.493 299.207 357.447 298.743 357.273 298.322C357.099 297.901 356.803 297.541 356.424 297.288C356.045 297.034 355.6 296.899 355.144 296.899C354.532 296.899 353.946 297.142 353.514 297.574C353.082 298.007 352.839 298.593 352.839 299.204Z",
    fill: "#263238"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M336.958 299.608H349.693C349.953 299.608 350.164 299.397 350.164 299.137V299.019C350.164 298.759 349.953 298.548 349.693 298.548H336.958C336.698 298.548 336.487 298.759 336.487 299.019V299.137C336.487 299.397 336.698 299.608 336.958 299.608Z",
    fill: "#263238"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M336.958 299.608H349.693C349.953 299.608 350.164 299.397 350.164 299.137V299.019C350.164 298.759 349.953 298.548 349.693 298.548H336.958C336.698 298.548 336.487 298.759 336.487 299.019V299.137C336.487 299.397 336.698 299.608 336.958 299.608Z",
    fill: "#1C262B"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M336.958 302.031H349.693C349.953 302.031 350.164 301.82 350.164 301.56V301.442C350.164 301.182 349.953 300.971 349.693 300.971H336.958C336.698 300.971 336.487 301.182 336.487 301.442V301.56C336.487 301.82 336.698 302.031 336.958 302.031Z",
    fill: "#263238"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M336.958 302.031H349.693C349.953 302.031 350.164 301.82 350.164 301.56V301.442C350.164 301.182 349.953 300.971 349.693 300.971H336.958C336.698 300.971 336.487 301.182 336.487 301.442V301.56C336.487 301.82 336.698 302.031 336.958 302.031Z",
    fill: "#1C262B"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M336.958 304.453H349.693C349.953 304.453 350.164 304.242 350.164 303.982V303.864C350.164 303.604 349.953 303.393 349.693 303.393H336.958C336.698 303.393 336.487 303.604 336.487 303.864V303.982C336.487 304.242 336.698 304.453 336.958 304.453Z",
    fill: "#263238"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M336.958 304.453H349.693C349.953 304.453 350.164 304.242 350.164 303.982V303.864C350.164 303.604 349.953 303.393 349.693 303.393H336.958C336.698 303.393 336.487 303.604 336.487 303.864V303.982C336.487 304.242 336.698 304.453 336.958 304.453Z",
    fill: "#1C262B"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M620.039 574.109L571.572 569.332V501.215H552.36V569.315L503.725 574.109C501.393 574.335 499.228 575.422 497.654 577.158C496.081 578.894 495.21 581.154 495.212 583.497V590.781H628.602V583.497C628.604 581.146 627.726 578.879 626.142 577.142C624.557 575.405 622.381 574.323 620.039 574.109Z",
    fill: "#263238"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M620.039 574.109L571.572 569.332V501.215H552.36V569.315L503.725 574.109C501.393 574.335 499.228 575.422 497.654 577.158C496.081 578.894 495.21 581.154 495.212 583.497V590.781H628.602V583.497C628.604 581.146 627.726 578.879 626.142 577.142C624.557 575.405 622.381 574.323 620.039 574.109Z",
    fill: "#1C262B"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M500.31 612.365C507.25 612.365 512.877 606.738 512.877 599.798C512.877 592.858 507.25 587.231 500.31 587.231C493.369 587.231 487.743 592.858 487.743 599.798C487.743 606.738 493.369 612.365 500.31 612.365Z",
    fill: "#263238"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M623.438 612.365C630.378 612.365 636.004 606.738 636.004 599.798C636.004 592.858 630.378 587.231 623.438 587.231C616.497 587.231 610.871 592.858 610.871 599.798C610.871 606.738 616.497 612.365 623.438 612.365Z",
    fill: "#263238"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M549.063 455.187H574.886V508.903C574.886 510.746 574.154 512.513 572.851 513.816C571.548 515.119 569.781 515.851 567.939 515.851H556.011C554.168 515.851 552.401 515.119 551.098 513.816C549.795 512.513 549.063 510.746 549.063 508.903V455.187Z",
    fill: "#263238"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M549.063 455.187H574.886V508.903C574.886 510.746 574.154 512.513 572.851 513.816C571.548 515.119 569.781 515.851 567.939 515.851H556.011C554.168 515.851 552.401 515.119 551.098 513.816C549.795 512.513 549.063 510.746 549.063 508.903V455.187Z",
    fill: "#1C262B"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M548.474 454.228C548.474 454.228 571.438 372.536 575.24 269.175C575.466 263.23 577.989 257.605 582.278 253.482C586.567 249.36 592.288 247.061 598.237 247.069H639.487C645.571 247.065 651.41 249.472 655.723 253.764C660.037 258.055 662.474 263.881 662.501 269.966C662.652 307.531 660.028 391.849 638.847 454.296L548.474 454.228Z",
    fill: "#263238"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M638.831 454.228H548.474C548.474 454.228 571.438 372.536 575.24 269.175C575.466 263.23 577.989 257.605 582.278 253.482C586.567 249.36 592.288 247.061 598.237 247.069H639.47C645.556 247.065 651.396 249.471 655.713 253.762C660.029 258.053 662.47 263.879 662.501 269.966C662.652 307.464 660.028 391.781 638.831 454.228Z",
    fill: "#1C262B"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M566.172 394.843C566.172 394.843 517.15 384.917 469.843 389.796C422.537 394.675 492.1 456.432 492.1 456.432H501.874C501.874 456.432 465.032 417.15 467.051 407.393C469.069 397.636 561.966 410.505 561.966 410.505L566.172 394.843Z",
    fill: "#263238"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M566.172 394.843C566.172 394.843 517.15 384.917 469.843 389.796C422.537 394.675 492.1 456.432 492.1 456.432H501.874C501.874 456.432 465.032 417.15 467.051 407.393C469.069 397.636 561.966 410.505 561.966 410.505L566.172 394.843Z",
    fill: "#1C262B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M638.831 454.228H558.568C558.568 454.228 581.531 372.536 585.333 269.175C585.56 263.23 588.083 257.605 592.372 253.482C596.661 249.36 602.381 247.061 608.33 247.069H639.47C645.556 247.065 651.396 249.471 655.713 253.762C660.029 258.053 662.47 263.879 662.501 269.966C662.652 307.464 660.028 391.781 638.831 454.228Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M533.232 455.187C533.232 455.187 557.306 378.34 561.411 266.197C561.659 259.753 564.395 253.655 569.044 249.184C573.693 244.714 579.893 242.22 586.343 242.224H631.058C637.656 242.224 643.986 244.836 648.664 249.489C653.342 254.142 655.988 260.457 656.024 267.055C656.192 307.801 653.349 391.075 630.369 458.838L533.232 455.187Z",
    fill: "url(#paint57_linear_2280_9187)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M533.232 455.187C533.232 455.187 557.306 378.34 561.411 266.197C561.659 259.753 564.395 253.655 569.044 249.184C573.693 244.714 579.893 242.22 586.343 242.224H631.058C637.656 242.224 643.986 244.836 648.664 249.489C653.342 254.142 655.988 260.457 656.024 267.055C656.192 307.801 653.349 391.075 630.369 458.838L533.232 455.187Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M624.985 462.135H473.713V450.881C473.713 448.65 474.599 446.51 476.176 444.933C477.754 443.355 479.893 442.469 482.124 442.469H616.574C618.805 442.469 620.944 443.355 622.522 444.933C624.099 446.51 624.985 448.65 624.985 450.881V462.135Z",
    fill: "url(#paint58_linear_2280_9187)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M624.985 462.135H473.713V450.881C473.713 448.65 474.599 446.51 476.176 444.933C477.754 443.355 479.893 442.469 482.124 442.469H616.574C618.805 442.469 620.944 443.355 622.522 444.933C624.099 446.51 624.985 448.65 624.985 450.881V462.135Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M471.694 462.152H637.081C638.949 462.152 640.463 460.638 640.463 458.771V455.709C640.463 453.842 638.949 452.328 637.081 452.328H471.694C469.826 452.328 468.312 453.842 468.312 455.709V458.771C468.312 460.638 469.826 462.152 471.694 462.152Z",
    fill: "#263238"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M471.694 462.152H637.081C638.949 462.152 640.463 460.638 640.463 458.771V455.709C640.463 453.842 638.949 452.328 637.081 452.328H471.694C469.826 452.328 468.312 453.842 468.312 455.709V458.771C468.312 460.638 469.826 462.152 471.694 462.152Z",
    fill: "#1C262B"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M567.686 462.152H637.081C638.949 462.152 640.463 460.638 640.463 458.771V455.709C640.463 453.842 638.949 452.328 637.081 452.328H567.686C565.819 452.328 564.305 453.842 564.305 455.709V458.771C564.305 460.638 565.819 462.152 567.686 462.152Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M649.362 395.869C649.362 395.869 652.558 384.917 605.235 389.729C557.912 394.54 627.492 456.365 627.492 456.365H637.266C637.266 456.365 600.39 417.15 602.442 407.393C604.495 397.636 645.156 411.532 645.156 411.532L649.362 395.869Z",
    fill: "#263238"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.362 395.869C649.362 395.869 652.558 384.917 605.235 389.729C557.912 394.54 627.492 456.365 627.492 456.365H637.266C637.266 456.365 600.39 417.15 602.442 407.393C604.495 397.636 645.156 411.532 645.156 411.532L649.362 395.869Z",
    fill: "#1C262B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M316.383 570.812C316.729 570.084 316.896 569.283 316.869 568.478C316.842 567.672 316.622 566.885 316.229 566.182C315.835 565.478 315.278 564.879 314.606 564.435C313.933 563.991 313.164 563.714 312.363 563.628C313.075 561.557 313.134 559.317 312.532 557.211C311.93 555.105 310.697 553.235 308.998 551.852C308.597 551.477 308.082 551.246 307.534 551.196C306.915 551.244 306.327 551.485 305.852 551.886L296.482 558.615C295.722 559.069 295.082 559.698 294.614 560.449C292.697 564.167 299.661 568.86 296.768 571.989C295.96 572.864 294.648 573.049 293.622 573.672C291.401 575.068 291.132 578.13 290.089 580.552C289.046 582.975 285.412 584.842 284.033 582.605C285.059 580.283 281.947 578.281 279.44 577.995C276.933 577.709 274.292 577.558 272.896 575.203C269.329 578.315 261.322 569.601 261.507 566.101C258.563 566.32 256.561 569.062 255.921 571.821C255.517 574.719 255.416 577.651 255.619 580.569C255.534 586.255 253.701 591.841 253.802 597.527C253.802 601.951 255.585 606.864 259.639 608.647C261.654 609.366 263.798 609.653 265.931 609.488L312.077 609.185C313.181 609.274 314.291 609.09 315.307 608.647C317.393 607.57 317.83 604.828 318.032 602.49L320.505 572.41L316.383 570.812Z",
    fill: "url(#paint59_linear_2280_9187)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M316.383 570.812C316.729 570.084 316.896 569.283 316.869 568.478C316.842 567.672 316.622 566.885 316.229 566.182C315.835 565.478 315.278 564.879 314.606 564.435C313.933 563.991 313.164 563.714 312.363 563.628C313.075 561.557 313.134 559.317 312.532 557.211C311.93 555.105 310.697 553.235 308.998 551.852C308.597 551.477 308.082 551.246 307.534 551.196C306.915 551.244 306.327 551.485 305.852 551.886L296.482 558.615C295.722 559.069 295.082 559.698 294.614 560.449C292.697 564.167 299.661 568.86 296.768 571.989C295.96 572.864 294.648 573.049 293.622 573.672C291.401 575.068 291.132 578.13 290.089 580.552C289.046 582.975 285.412 584.842 284.033 582.605C285.059 580.283 281.947 578.281 279.44 577.995C276.933 577.709 274.292 577.558 272.896 575.203C269.329 578.315 261.322 569.601 261.507 566.101C258.563 566.32 256.561 569.062 255.921 571.821C255.517 574.719 255.416 577.651 255.619 580.569C255.534 586.255 253.701 591.841 253.802 597.527C253.802 601.951 255.585 606.864 259.639 608.647C261.654 609.366 263.798 609.653 265.931 609.488L312.077 609.185C313.181 609.274 314.291 609.09 315.307 608.647C317.393 607.57 317.83 604.828 318.032 602.49L320.505 572.41L316.383 570.812Z",
    fill: "#1C262B"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M319.075 522.042H247.476L248.065 529.276L248.486 534.44L249.579 547.899L250.202 555.621L251.026 565.899L251.379 570.307L251.497 571.619L251.918 576.801L252.49 583.9L252.843 588.308L253.213 592.783L253.633 597.964L253.953 601.884L254.306 606.292L254.458 608.209H320.169L320.32 606.292L320.673 601.901L320.993 597.947L321.414 592.766L321.784 588.308L322.137 583.9L322.709 576.784L323.129 571.619L323.23 570.307L323.584 565.899L324.425 555.621L325.047 547.916L326.124 534.457L326.545 529.292L327.133 522.059L319.075 522.042ZM323.382 526.752L322.002 525.373H323.5L323.382 526.752ZM323.029 531.143L322.894 532.825L316.484 539.235L309.133 531.883L315.71 525.305H317.258L323.029 531.143ZM321.178 554.056L316.484 558.716L309.133 551.364L316.484 544.029L321.531 549.076L321.178 554.056ZM253.061 549.177L258.108 544.13L265.46 551.465L258.108 558.716L253.432 554.022L253.061 549.177ZM314.129 541.708L306.777 549.06L299.426 541.708L306.777 534.356L314.129 541.708ZM302.572 525.406H310.983L306.777 529.612L302.572 525.406ZM304.389 551.432L297.037 558.716L289.685 551.364L297.037 544.029L304.389 551.432ZM279.978 561.155L287.33 553.82L294.665 561.155L287.33 568.507L279.978 561.155ZM284.941 570.879L277.589 578.231L270.255 570.896L277.606 563.544L284.941 570.879ZM297.054 563.544L304.389 570.896L297.054 578.231L289.702 570.879L297.054 563.544ZM287.33 549.06L279.978 541.708L287.33 534.356L294.665 541.708L287.33 549.06ZM284.941 551.432L277.589 558.716L270.238 551.364L277.589 544.029L284.941 551.432ZM267.866 549.06L260.531 541.708L267.866 534.356L275.217 541.708L267.866 549.06ZM267.866 553.82L275.217 561.155L267.866 568.507L260.531 561.155L267.866 553.82ZM275.201 580.586L267.849 587.921L260.514 580.586L267.849 573.234L275.201 580.586ZM277.573 582.958L284.924 590.31L277.589 597.661L270.238 590.31L277.573 582.958ZM279.978 580.586L287.33 573.234L294.665 580.586L287.33 587.921L279.978 580.586ZM297.054 582.958L304.389 590.31L297.054 597.661L289.702 590.31L297.054 582.958ZM306.777 592.682L314.129 600.033L309.368 604.794H304.187L299.426 600.033L306.777 592.682ZM299.409 580.586L306.761 573.234L314.112 580.586L306.761 587.921L299.409 580.586ZM299.409 561.122L306.761 553.787L314.112 561.122L306.761 568.473L299.409 561.122ZM304.372 531.95L297.037 539.302L289.685 531.95L296.263 525.373H297.811L304.372 531.95ZM287.313 529.578L283.107 525.373H291.519L287.313 529.578ZM284.924 531.95L277.589 539.302L270.238 531.95L276.816 525.373H278.296L284.924 531.95ZM272.055 525.373L267.849 529.578L263.66 525.373H272.055ZM258.899 525.373L265.477 531.95L258.108 539.336L251.716 532.926L251.581 531.244L257.335 525.474L258.899 525.373ZM252.607 525.373L251.245 526.735L251.127 525.373H252.607ZM252.153 538.074L255.753 541.674L252.691 544.736L252.153 538.074ZM254.155 562.72L253.869 559.237L255.753 561.122L254.155 562.72ZM254.508 567.144L258.125 563.511L265.477 570.862L258.108 578.231L255.148 575.27L254.508 567.144ZM255.602 580.737V580.418L255.77 580.586L255.619 580.737H255.602ZM256.88 596.4L255.955 585.128L258.125 582.958L265.477 590.31L258.108 597.678L256.863 596.433L256.88 596.4ZM257.553 604.811L257.419 603.129L258.108 602.456L260.497 604.845L257.553 604.811ZM260.514 600.05L267.849 592.699L275.201 600.05L270.44 604.811H265.258L260.514 600.05ZM275.201 604.811L277.589 602.422L279.978 604.811H275.201ZM284.722 604.811L279.978 600.067L287.33 592.715L294.665 600.067L289.921 604.828L284.722 604.811ZM294.648 604.811L297.037 602.422L299.426 604.811H294.648ZM317.056 604.811H314.095L316.484 602.456L317.191 603.162L317.056 604.811ZM317.746 596.4L316.484 597.644L309.133 590.31L316.484 582.958L318.655 585.128L317.746 596.4ZM319.041 580.401V580.737L318.89 580.586L319.075 580.401H319.041ZM319.462 575.236L316.484 578.197L309.133 570.862L316.484 563.511L320.118 567.144L319.462 575.236ZM320.471 562.737L318.789 561.054L320.69 559.17L320.471 562.737ZM322.473 538.057L321.935 544.786L318.856 541.708L322.473 538.091V538.057Z",
    fill: "url(#paint60_linear_2280_9187)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.075 522.042H247.476L248.065 529.276L248.486 534.44L249.579 547.899L250.202 555.621L251.026 565.899L251.379 570.307L251.497 571.619L251.918 576.801L252.49 583.9L252.843 588.308L253.213 592.783L253.633 597.964L253.953 601.884L254.306 606.292L254.458 608.209H320.169L320.32 606.292L320.673 601.901L320.993 597.947L321.414 592.766L321.784 588.308L322.137 583.9L322.709 576.784L323.129 571.619L323.23 570.307L323.584 565.899L324.425 555.621L325.047 547.916L326.124 534.457L326.545 529.292L327.133 522.059L319.075 522.042ZM323.382 526.752L322.002 525.373H323.5L323.382 526.752ZM323.029 531.143L322.894 532.825L316.484 539.235L309.133 531.883L315.71 525.305H317.258L323.029 531.143ZM321.178 554.056L316.484 558.716L309.133 551.364L316.484 544.029L321.531 549.076L321.178 554.056ZM253.061 549.177L258.108 544.13L265.46 551.465L258.108 558.716L253.432 554.022L253.061 549.177ZM314.129 541.708L306.777 549.06L299.426 541.708L306.777 534.356L314.129 541.708ZM302.572 525.406H310.983L306.777 529.612L302.572 525.406ZM304.389 551.432L297.037 558.716L289.685 551.364L297.037 544.029L304.389 551.432ZM279.978 561.155L287.33 553.82L294.665 561.155L287.33 568.507L279.978 561.155ZM284.941 570.879L277.589 578.231L270.255 570.896L277.606 563.544L284.941 570.879ZM297.054 563.544L304.389 570.896L297.054 578.231L289.702 570.879L297.054 563.544ZM287.33 549.06L279.978 541.708L287.33 534.356L294.665 541.708L287.33 549.06ZM284.941 551.432L277.589 558.716L270.238 551.364L277.589 544.029L284.941 551.432ZM267.866 549.06L260.531 541.708L267.866 534.356L275.217 541.708L267.866 549.06ZM267.866 553.82L275.217 561.155L267.866 568.507L260.531 561.155L267.866 553.82ZM275.201 580.586L267.849 587.921L260.514 580.586L267.849 573.234L275.201 580.586ZM277.573 582.958L284.924 590.31L277.589 597.661L270.238 590.31L277.573 582.958ZM279.978 580.586L287.33 573.234L294.665 580.586L287.33 587.921L279.978 580.586ZM297.054 582.958L304.389 590.31L297.054 597.661L289.702 590.31L297.054 582.958ZM306.777 592.682L314.129 600.033L309.368 604.794H304.187L299.426 600.033L306.777 592.682ZM299.409 580.586L306.761 573.234L314.112 580.586L306.761 587.921L299.409 580.586ZM299.409 561.122L306.761 553.787L314.112 561.122L306.761 568.473L299.409 561.122ZM304.372 531.95L297.037 539.302L289.685 531.95L296.263 525.373H297.811L304.372 531.95ZM287.313 529.578L283.107 525.373H291.519L287.313 529.578ZM284.924 531.95L277.589 539.302L270.238 531.95L276.816 525.373H278.296L284.924 531.95ZM272.055 525.373L267.849 529.578L263.66 525.373H272.055ZM258.899 525.373L265.477 531.95L258.108 539.336L251.716 532.926L251.581 531.244L257.335 525.474L258.899 525.373ZM252.607 525.373L251.245 526.735L251.127 525.373H252.607ZM252.153 538.074L255.753 541.674L252.691 544.736L252.153 538.074ZM254.155 562.72L253.869 559.237L255.753 561.122L254.155 562.72ZM254.508 567.144L258.125 563.511L265.477 570.862L258.108 578.231L255.148 575.27L254.508 567.144ZM255.602 580.737V580.418L255.77 580.586L255.619 580.737H255.602ZM256.88 596.4L255.955 585.128L258.125 582.958L265.477 590.31L258.108 597.678L256.863 596.433L256.88 596.4ZM257.553 604.811L257.419 603.129L258.108 602.456L260.497 604.845L257.553 604.811ZM260.514 600.05L267.849 592.699L275.201 600.05L270.44 604.811H265.258L260.514 600.05ZM275.201 604.811L277.589 602.422L279.978 604.811H275.201ZM284.722 604.811L279.978 600.067L287.33 592.715L294.665 600.067L289.921 604.828L284.722 604.811ZM294.648 604.811L297.037 602.422L299.426 604.811H294.648ZM317.056 604.811H314.095L316.484 602.456L317.191 603.162L317.056 604.811ZM317.746 596.4L316.484 597.644L309.133 590.31L316.484 582.958L318.655 585.128L317.746 596.4ZM319.041 580.401V580.737L318.89 580.586L319.075 580.401H319.041ZM319.462 575.236L316.484 578.197L309.133 570.862L316.484 563.511L320.118 567.144L319.462 575.236ZM320.471 562.737L318.789 561.054L320.69 559.17L320.471 562.737ZM322.473 538.057L321.935 544.786L318.856 541.708L322.473 538.091V538.057Z",
    fill: "#1C262B"
  }))), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M245.659 528.418H328.967C330.491 528.418 331.726 527.182 331.726 525.659V521.806C331.726 520.282 330.491 519.047 328.967 519.047H245.659C244.136 519.047 242.9 520.282 242.9 521.806V525.659C242.9 527.182 244.136 528.418 245.659 528.418Z",
    fill: "url(#paint61_linear_2280_9187)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M322.557 603.146H252.052C250.528 603.146 249.293 604.381 249.293 605.905V609.757C249.293 611.281 250.528 612.516 252.052 612.516H322.557C324.081 612.516 325.316 611.281 325.316 609.757V605.905C325.316 604.381 324.081 603.146 322.557 603.146Z",
    fill: "url(#paint62_linear_2280_9187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2280_9187",
    x1: 278.611,
    y1: 346.562,
    x2: 279.402,
    y2: 371.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2280_9187",
    x1: 273.701,
    y1: 341.7,
    x2: 273.943,
    y2: 355.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2280_9187",
    x1: 491.984,
    y1: 26.5187,
    x2: 612.294,
    y2: 170.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2280_9187",
    x1: 469.746,
    y1: 83.0238,
    x2: 489.272,
    y2: 99.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2280_9187",
    x1: 491.666,
    y1: 83.0238,
    x2: 511.192,
    y2: 99.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2280_9187",
    x1: 514.102,
    y1: 80.136,
    x2: 544.841,
    y2: 94.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2280_9187",
    x1: 469.746,
    y1: 104.944,
    x2: 489.272,
    y2: 121.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2280_9187",
    x1: 472.732,
    y1: 132.731,
    x2: 503.431,
    y2: 158.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2280_9187",
    x1: 501.805,
    y1: 134.864,
    x2: 517.154,
    y2: 147.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2280_9187",
    x1: 501.805,
    y1: 151.902,
    x2: 516.545,
    y2: 165.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2280_9187",
    x1: 518.914,
    y1: 134.864,
    x2: 534.263,
    y2: 147.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2280_9187",
    x1: 518.914,
    y1: 151.902,
    x2: 533.654,
    y2: 165.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2280_9187",
    x1: 491.666,
    y1: 104.944,
    x2: 511.192,
    y2: 121.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2280_9187",
    x1: 546.324,
    y1: 83.0238,
    x2: 565.85,
    y2: 99.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2280_9187",
    x1: 568.245,
    y1: 83.0238,
    x2: 587.77,
    y2: 99.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2280_9187",
    x1: 590.681,
    y1: 80.136,
    x2: 621.42,
    y2: 94.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2280_9187",
    x1: 546.324,
    y1: 104.944,
    x2: 565.85,
    y2: 121.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2280_9187",
    x1: 549.311,
    y1: 132.731,
    x2: 580.01,
    y2: 158.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2280_9187",
    x1: 578.383,
    y1: 134.864,
    x2: 593.733,
    y2: 147.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2280_9187",
    x1: 578.383,
    y1: 151.902,
    x2: 593.124,
    y2: 165.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2280_9187",
    x1: 595.492,
    y1: 134.864,
    x2: 610.842,
    y2: 147.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2280_9187",
    x1: 595.492,
    y1: 151.902,
    x2: 610.233,
    y2: 165.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2280_9187",
    x1: 568.245,
    y1: 104.944,
    x2: 587.77,
    y2: 121.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2280_9187",
    x1: 520.07,
    y1: 129.548,
    x2: 522.757,
    y2: 137.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2280_9187",
    x1: 596.648,
    y1: 129.548,
    x2: 599.336,
    y2: 137.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2280_9187",
    x1: 598.432,
    y1: 59.4127,
    x2: 601.496,
    y2: 66.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2280_9187",
    x1: 581.776,
    y1: 59.4127,
    x2: 584.464,
    y2: 66.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2280_9187",
    x1: 470.879,
    y1: 68.1392,
    x2: 477.136,
    y2: 80.4892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2280_9187",
    x1: 538.456,
    y1: 91.0548,
    x2: 640.86,
    y2: 230.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2280_9187",
    x1: 535.008,
    y1: 101.248,
    x2: 609.56,
    y2: 198.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2280_9187",
    x1: 535.012,
    y1: 192.716,
    x2: 543.506,
    y2: 233.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2280_9187",
    x1: 640.989,
    y1: 98.1585,
    x2: 690.937,
    y2: 111.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2280_9187",
    x1: 641.599,
    y1: 109.701,
    x2: 666.79,
    y2: 134.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2280_9187",
    x1: 583.32,
    y1: 161.862,
    x2: 661.91,
    y2: 269.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2280_9187",
    x1: 585.971,
    y1: 174.311,
    x2: 586.727,
    y2: 186.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2280_9187",
    x1: 585.971,
    y1: 179.809,
    x2: 613.407,
    y2: 249.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2280_9187",
    x1: 610.695,
    y1: 228.276,
    x2: 626.276,
    y2: 274.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2280_9187",
    x1: 567.568,
    y1: 223.114,
    x2: 572.913,
    y2: 232.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2280_9187",
    x1: 563.186,
    y1: 225.125,
    x2: 566.4,
    y2: 227.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2280_9187",
    x1: 578.404,
    y1: 223.687,
    x2: 581.923,
    y2: 226.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2280_9187",
    x1: 238.218,
    y1: 20.3884,
    x2: 389.522,
    y2: 217.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2280_9187",
    x1: 195.444,
    y1: 48.2236,
    x2: 279.053,
    y2: 81.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2280_9187",
    x1: 240.863,
    y1: 44.0218,
    x2: 242.295,
    y2: 67.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2280_9187",
    x1: 284.971,
    y1: 57.908,
    x2: 317.157,
    y2: 149.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2280_9187",
    x1: 287.772,
    y1: 123.926,
    x2: 289.971,
    y2: 148.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2280_9187",
    x1: 287.772,
    y1: 139.985,
    x2: 312.708,
    y2: 220.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2280_9187",
    x1: 205.033,
    y1: 215.555,
    x2: 281.75,
    y2: 317.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2280_9187",
    x1: 197.701,
    y1: 230.397,
    x2: 212.627,
    y2: 250.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2280_9187",
    x1: 197.701,
    y1: 230.397,
    x2: 212.627,
    y2: 250.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2280_9187",
    x1: 199.32,
    y1: 247.894,
    x2: 214.233,
    y2: 267.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2280_9187",
    x1: 199.32,
    y1: 247.894,
    x2: 214.233,
    y2: 267.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2280_9187",
    x1: 200.93,
    y1: 265.736,
    x2: 215.905,
    y2: 285.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2280_9187",
    x1: 200.93,
    y1: 265.736,
    x2: 215.905,
    y2: 285.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2280_9187",
    x1: 202.494,
    y1: 283.272,
    x2: 217.386,
    y2: 303.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2280_9187",
    x1: 202.494,
    y1: 283.272,
    x2: 217.386,
    y2: 303.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2280_9187",
    x1: 354.468,
    y1: 214.089,
    x2: 432.383,
    y2: 317.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2280_9187",
    x1: 413.658,
    y1: 295.34,
    x2: 413.336,
    y2: 287.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2280_9187",
    x1: 564.329,
    y1: 213.709,
    x2: 727.279,
    y2: 292.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2280_9187",
    x1: 586.678,
    y1: 464.724,
    x2: 581.06,
    y2: 427.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2280_9187",
    x1: 270.69,
    y1: 543.517,
    x2: 326.642,
    y2: 598.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2280_9187",
    x1: 267.648,
    y1: 510.699,
    x2: 348.048,
    y2: 574.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2280_9187",
    x1: 309.232,
    y1: 529.651,
    x2: 307.043,
    y2: 511.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2280_9187",
    x1: 268.545,
    y1: 601.912,
    x2: 271.089,
    y2: 619.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurCulture);
export default __webpack_public_path__ + "static/media/OurCulture.7593c501648816c55887d7c5be466c8b.svg";
export { ForwardRef as ReactComponent };